// import React, { useState, useEffect } from 'react';
// import { Save, Upload, X } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import config from '../../config';
// import axios from "axios";

// const FacadePageManage = () => {
//   const navigate = useNavigate();

//   const [activeLanguage, setActiveLanguage] = useState('en');
//   const [contentId, setContentId] = useState(null);
//   const [isNewContent, setIsNewContent] = useState(false);

//   // English (default) form data
//   const [formData, setFormData] = useState({
//     hero: {
//       title: '',
//       subtitle: '',
//       paragraphs: ['']
//     },
//     navigation: {
//       aboutUs: '',
//       ourTeam: ''
//     },
//     textBanner: {
//       title: '',
//       paragraphs: ['']
//     },
//     textBanner2: {
//       title: '',
//       paragraphs: ['']
//     },
//     sections: {
//       whatWeOffer: '',
//       ourProcess: ''
//     },
//     offers: [{ icon: '', title: '', desc: '' }],
//     process: [{ icon: '', title: '', desc: '' }],
//     disclaimer: {
//       title: '',
//       text: ''
//     },
//     section3: {
//       title: '',
//       paragraphs: ['']
//     }
//   });

//   // Spanish translation form data
//   const [spanishData, setSpanishData] = useState({
//     hero: {
//       title: '',
//       subtitle: '',
//       paragraphs: ['']
//     },
//     navigation: {
//       aboutUs: '',
//       ourTeam: ''
//     },
//     textBanner: {
//       title: '',
//       paragraphs: ['']
//     },
//     textBanner2: {
//       title: '',
//       paragraphs: ['']
//     },
//     sections: {
//       whatWeOffer: '',
//       ourProcess: ''
//     },
//     offers: [{ icon: '', title: '', desc: '' }],
//     process: [{ icon: '', title: '', desc: '' }],
//     disclaimer: {
//       title: '',
//       text: ''
//     },
//     section3: {
//       title: '',
//       paragraphs: ['']
//     }
//   });

//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [successMessage, setSuccessMessage] = useState('');

//   useEffect(() => {
//     const fetchFacadePage = async () => {
//       try {
//         const response = await axios.get(`${config.BASE_URL}/api/admin/facade-page?includeSpanish=true`, {
//           withCredentials: true,
//           headers: {
//             'Content-Type': 'application/json'
//           }
//         });

//         if (response.data && response.data.data && response.data.data.length > 0) {
//           const data = response.data.data[0];
//           setContentId(data._id);
//           setIsNewContent(false);

//           setFormData({
//             hero: {
//               title: data.hero?.title || '',
//               subtitle: data.hero?.subtitle || '',
//               paragraphs: data.hero?.paragraphs?.length > 0 ? data.hero.paragraphs : ['']
//             },
//             navigation: {
//               aboutUs: data.navigation?.aboutUs || '',
//               ourTeam: data.navigation?.ourTeam || ''
//             },
//             textBanner: {
//               title: data.textBanner?.title || '',
//               paragraphs: data.textBanner?.paragraphs?.length > 0 ? data.textBanner.paragraphs : ['']
//             },
//             textBanner2: {
//               title: data.textBanner2?.title || '',
//               paragraphs: data.textBanner2?.paragraphs?.length > 0 ? data.textBanner2.paragraphs : ['']
//             },
//             sections: {
//               whatWeOffer: data.sections?.whatWeOffer || '',
//               ourProcess: data.sections?.ourProcess || ''
//             },
//             offers: data.offers?.length > 0 ? data.offers : [{ icon: '', title: '', desc: '' }],
//             process: data.process?.length > 0 ? data.process : [{ icon: '', title: '', desc: '' }],
//             disclaimer: {
//               title: data.disclaimer?.title || '',
//               text: data.disclaimer?.text || ''
//             },
//             section3: {
//               title: data.section3?.title || '',
//               paragraphs: data.section3?.paragraphs?.length > 0 ? data.section3.paragraphs : ['']
//             }
//           });

//           setSpanishData({
//             hero: {
//               title: data.spanishData?.hero?.title || '',
//               subtitle: data.spanishData?.hero?.subtitle || '',
//               paragraphs: data.spanishData?.hero?.paragraphs?.length > 0 ? data.spanishData.hero.paragraphs : ['']
//             },
//             navigation: {
//               aboutUs: data.spanishData?.navigation?.aboutUs || '',
//               ourTeam: data.spanishData?.navigation?.ourTeam || ''
//             },
//             textBanner: {
//               title: data.spanishData?.textBanner?.title || '',
//               paragraphs: data.spanishData?.textBanner?.paragraphs?.length > 0 ? data.spanishData.textBanner.paragraphs : ['']
//             },
//             textBanner2: {
//               title: data.spanishData?.textBanner2?.title || '',
//               paragraphs: data.spanishData?.textBanner2?.paragraphs?.length > 0 ? data.spanishData.textBanner2.paragraphs : ['']
//             },
//             sections: {
//               whatWeOffer: data.spanishData?.sections?.whatWeOffer || '',
//               ourProcess: data.spanishData?.sections?.ourProcess || ''
//             },
//             offers: data.spanishData?.offers?.length > 0 ? data.spanishData.offers : [{ icon: '', title: '', desc: '' }],
//             process: data.spanishData?.process?.length > 0 ? data.spanishData.process : [{ icon: '', title: '', desc: '' }],
//             disclaimer: {
//               title: data.spanishData?.disclaimer?.title || '',
//               text: data.spanishData?.disclaimer?.text || ''
//             },
//             section3: {
//               title: data.spanishData?.section3?.title || '',
//               paragraphs: data.spanishData?.section3?.paragraphs?.length > 0 ? data.spanishData.section3.paragraphs : ['']
//             }
//           });
//         } else {
//           setIsNewContent(true);
//         }
//       } catch (err) {
//         console.error('Error fetching facade page:', err);
//         if (err.response?.status === 404 || err.response?.status === 400) {
//           setIsNewContent(true);
//         } else if (err.response?.status === 401) {
//           setErrors({ submit: 'Authentication failed. Please login again.' });
//           setTimeout(() => navigate('/admin/login'), 2000);
//         } else {
//           setErrors({ submit: 'Failed to fetch facade page details' });
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchFacadePage();
//   }, [navigate]);

//   // English handlers
//   const handleHeroChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       hero: { ...prev.hero, [field]: value }
//     }));
//   };

//   const handleHeroParagraphChange = (index, value) => {
//     const newParagraphs = [...formData.hero.paragraphs];
//     newParagraphs[index] = value;
//     setFormData(prev => ({
//       ...prev,
//       hero: { ...prev.hero, paragraphs: newParagraphs }
//     }));
//   };

//   const addHeroParagraph = () => {
//     setFormData(prev => ({
//       ...prev,
//       hero: { ...prev.hero, paragraphs: [...prev.hero.paragraphs, ''] }
//     }));
//   };

//   const removeHeroParagraph = (index) => {
//     if (formData.hero.paragraphs.length > 1) {
//       const newParagraphs = formData.hero.paragraphs.filter((_, i) => i !== index);
//       setFormData(prev => ({
//         ...prev,
//         hero: { ...prev.hero, paragraphs: newParagraphs }
//       }));
//     }
//   };

//   const handleNavigationChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       navigation: { ...prev.navigation, [field]: value }
//     }));
//   };

//   const handleTextBannerChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       textBanner: { ...prev.textBanner, [field]: value }
//     }));
//   };

//   const handleTextBannerParagraphChange = (index, value) => {
//     const newParagraphs = [...formData.textBanner.paragraphs];
//     newParagraphs[index] = value;
//     setFormData(prev => ({
//       ...prev,
//       textBanner: { ...prev.textBanner, paragraphs: newParagraphs }
//     }));
//   };

//   const addTextBannerParagraph = () => {
//     setFormData(prev => ({
//       ...prev,
//       textBanner: { ...prev.textBanner, paragraphs: [...prev.textBanner.paragraphs, ''] }
//     }));
//   };

//   const removeTextBannerParagraph = (index) => {
//     if (formData.textBanner.paragraphs.length > 1) {
//       const newParagraphs = formData.textBanner.paragraphs.filter((_, i) => i !== index);
//       setFormData(prev => ({
//         ...prev,
//         textBanner: { ...prev.textBanner, paragraphs: newParagraphs }
//       }));
//     }
//   };

//   const handleTextBanner2Change = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       textBanner2: { ...prev.textBanner2, [field]: value }
//     }));
//   };

//   const handleTextBanner2ParagraphChange = (index, value) => {
//     const newParagraphs = [...formData.textBanner2.paragraphs];
//     newParagraphs[index] = value;
//     setFormData(prev => ({
//       ...prev,
//       textBanner2: { ...prev.textBanner2, paragraphs: newParagraphs }
//     }));
//   };

//   const addTextBanner2Paragraph = () => {
//     setFormData(prev => ({
//       ...prev,
//       textBanner2: { ...prev.textBanner2, paragraphs: [...prev.textBanner2.paragraphs, ''] }
//     }));
//   };

//   const removeTextBanner2Paragraph = (index) => {
//     if (formData.textBanner2.paragraphs.length > 1) {
//       const newParagraphs = formData.textBanner2.paragraphs.filter((_, i) => i !== index);
//       setFormData(prev => ({
//         ...prev,
//         textBanner2: { ...prev.textBanner2, paragraphs: newParagraphs }
//       }));
//     }
//   };

//   const handleSectionsChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       sections: { ...prev.sections, [field]: value }
//     }));
//   };

//   const handleOfferChange = (index, field, value) => {
//     const newOffers = [...formData.offers];
//     newOffers[index] = { ...newOffers[index], [field]: value };
//     setFormData(prev => ({ ...prev, offers: newOffers }));
//   };

//   const addOffer = () => {
//     setFormData(prev => ({
//       ...prev,
//       offers: [...prev.offers, { icon: '', title: '', desc: '' }]
//     }));
//   };

//   const removeOffer = (index) => {
//     if (formData.offers.length > 1) {
//       const newOffers = formData.offers.filter((_, i) => i !== index);
//       setFormData(prev => ({ ...prev, offers: newOffers }));
//     }
//   };

//   const handleProcessChange = (index, field, value) => {
//     const newProcess = [...formData.process];
//     newProcess[index] = { ...newProcess[index], [field]: value };
//     setFormData(prev => ({ ...prev, process: newProcess }));
//   };

//   const addProcess = () => {
//     setFormData(prev => ({
//       ...prev,
//       process: [...prev.process, { icon: '', title: '', desc: '' }]
//     }));
//   };

//   const removeProcess = (index) => {
//     if (formData.process.length > 1) {
//       const newProcess = formData.process.filter((_, i) => i !== index);
//       setFormData(prev => ({ ...prev, process: newProcess }));
//     }
//   };

//   const handleDisclaimerChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       disclaimer: { ...prev.disclaimer, [field]: value }
//     }));
//   };

//   const handleSection3Change = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       section3: { ...prev.section3, [field]: value }
//     }));
//   };

//   const handleSection3ParagraphChange = (index, value) => {
//     const newParagraphs = [...formData.section3.paragraphs];
//     newParagraphs[index] = value;
//     setFormData(prev => ({
//       ...prev,
//       section3: { ...prev.section3, paragraphs: newParagraphs }
//     }));
//   };

//   const addSection3Paragraph = () => {
//     setFormData(prev => ({
//       ...prev,
//       section3: { ...prev.section3, paragraphs: [...prev.section3.paragraphs, ''] }
//     }));
//   };

//   const removeSection3Paragraph = (index) => {
//     if (formData.section3.paragraphs.length > 1) {
//       const newParagraphs = formData.section3.paragraphs.filter((_, i) => i !== index);
//       setFormData(prev => ({
//         ...prev,
//         section3: { ...prev.section3, paragraphs: newParagraphs }
//       }));
//     }
//   };

//   // Spanish handlers (similar structure)
//   const handleSpanishHeroChange = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       hero: { ...prev.hero, [field]: value }
//     }));
//   };

//   const handleSpanishHeroParagraphChange = (index, value) => {
//     const newParagraphs = [...spanishData.hero.paragraphs];
//     newParagraphs[index] = value;
//     setSpanishData(prev => ({
//       ...prev,
//       hero: { ...prev.hero, paragraphs: newParagraphs }
//     }));
//   };

//   const addSpanishHeroParagraph = () => {
//     setSpanishData(prev => ({
//       ...prev,
//       hero: { ...prev.hero, paragraphs: [...prev.hero.paragraphs, ''] }
//     }));
//   };

//   const removeSpanishHeroParagraph = (index) => {
//     if (spanishData.hero.paragraphs.length > 1) {
//       const newParagraphs = spanishData.hero.paragraphs.filter((_, i) => i !== index);
//       setSpanishData(prev => ({
//         ...prev,
//         hero: { ...prev.hero, paragraphs: newParagraphs }
//       }));
//     }
//   };

//   const handleSpanishNavigationChange = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       navigation: { ...prev.navigation, [field]: value }
//     }));
//   };

//   const handleSpanishTextBannerChange = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       textBanner: { ...prev.textBanner, [field]: value }
//     }));
//   };

//   const handleSpanishTextBannerParagraphChange = (index, value) => {
//     const newParagraphs = [...spanishData.textBanner.paragraphs];
//     newParagraphs[index] = value;
//     setSpanishData(prev => ({
//       ...prev,
//       textBanner: { ...prev.textBanner, paragraphs: newParagraphs }
//     }));
//   };

//   const addSpanishTextBannerParagraph = () => {
//     setSpanishData(prev => ({
//       ...prev,
//       textBanner: { ...prev.textBanner, paragraphs: [...prev.textBanner.paragraphs, ''] }
//     }));
//   };

//   const removeSpanishTextBannerParagraph = (index) => {
//     if (spanishData.textBanner.paragraphs.length > 1) {
//       const newParagraphs = spanishData.textBanner.paragraphs.filter((_, i) => i !== index);
//       setSpanishData(prev => ({
//         ...prev,
//         textBanner: { ...prev.textBanner, paragraphs: newParagraphs }
//       }));
//     }
//   };

//   const handleSpanishTextBanner2Change = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       textBanner2: { ...prev.textBanner2, [field]: value }
//     }));
//   };

//   const handleSpanishTextBanner2ParagraphChange = (index, value) => {
//     const newParagraphs = [...spanishData.textBanner2.paragraphs];
//     newParagraphs[index] = value;
//     setSpanishData(prev => ({
//       ...prev,
//       textBanner2: { ...prev.textBanner2, paragraphs: newParagraphs }
//     }));
//   };

//   const addSpanishTextBanner2Paragraph = () => {
//     setSpanishData(prev => ({
//       ...prev,
//       textBanner2: { ...prev.textBanner2, paragraphs: [...prev.textBanner2.paragraphs, ''] }
//     }));
//   };

//   const removeSpanishTextBanner2Paragraph = (index) => {
//     if (spanishData.textBanner2.paragraphs.length > 1) {
//       const newParagraphs = spanishData.textBanner2.paragraphs.filter((_, i) => i !== index);
//       setSpanishData(prev => ({
//         ...prev,
//         textBanner2: { ...prev.textBanner2, paragraphs: newParagraphs }
//       }));
//     }
//   };

//   const handleSpanishSectionsChange = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       sections: { ...prev.sections, [field]: value }
//     }));
//   };

//   const handleSpanishOfferChange = (index, field, value) => {
//     const newOffers = [...spanishData.offers];
//     newOffers[index] = { ...newOffers[index], [field]: value };
//     setSpanishData(prev => ({ ...prev, offers: newOffers }));
//   };

//   const addSpanishOffer = () => {
//     setSpanishData(prev => ({
//       ...prev,
//       offers: [...prev.offers, { icon: '', title: '', desc: '' }]
//     }));
//   };

//   const removeSpanishOffer = (index) => {
//     if (spanishData.offers.length > 1) {
//       const newOffers = spanishData.offers.filter((_, i) => i !== index);
//       setSpanishData(prev => ({ ...prev, offers: newOffers }));
//     }
//   };

//   const handleSpanishProcessChange = (index, field, value) => {
//     const newProcess = [...spanishData.process];
//     newProcess[index] = { ...newProcess[index], [field]: value };
//     setSpanishData(prev => ({ ...prev, process: newProcess }));
//   };

//   const addSpanishProcess = () => {
//     setSpanishData(prev => ({
//       ...prev,
//       process: [...prev.process, { icon: '', title: '', desc: '' }]
//     }));
//   };

//   const removeSpanishProcess = (index) => {
//     if (spanishData.process.length > 1) {
//       const newProcess = spanishData.process.filter((_, i) => i !== index);
//       setSpanishData(prev => ({ ...prev, process: newProcess }));
//     }
//   };

//   const handleSpanishDisclaimerChange = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       disclaimer: { ...prev.disclaimer, [field]: value }
//     }));
//   };

//   const handleSpanishSection3Change = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       section3: { ...prev.section3, [field]: value }
//     }));
//   };

//   const handleSpanishSection3ParagraphChange = (index, value) => {
//     const newParagraphs = [...spanishData.section3.paragraphs];
//     newParagraphs[index] = value;
//     setSpanishData(prev => ({
//       ...prev,
//       section3: { ...prev.section3, paragraphs: newParagraphs }
//     }));
//   };

//   const addSpanishSection3Paragraph = () => {
//     setSpanishData(prev => ({
//       ...prev,
//       section3: { ...prev.section3, paragraphs: [...prev.section3.paragraphs, ''] }
//     }));
//   };

//   const removeSpanishSection3Paragraph = (index) => {
//     if (spanishData.section3.paragraphs.length > 1) {
//       const newParagraphs = spanishData.section3.paragraphs.filter((_, i) => i !== index);
//       setSpanishData(prev => ({
//         ...prev,
//         section3: { ...prev.section3, paragraphs: newParagraphs }
//       }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.hero.title.trim()) newErrors['hero.title'] = 'Hero title is required';
//     if (!formData.hero.subtitle.trim()) newErrors['hero.subtitle'] = 'Hero subtitle is required';
//     if (!formData.navigation.aboutUs.trim()) newErrors['navigation.aboutUs'] = 'About Us navigation is required';
//     if (!formData.navigation.ourTeam.trim()) newErrors['navigation.ourTeam'] = 'Our Team navigation is required';
//     if (!formData.textBanner.title.trim()) newErrors['textBanner.title'] = 'Text Banner title is required';
//     if (!formData.textBanner2.title.trim()) newErrors['textBanner2.title'] = 'Text Banner 2 title is required';
//     if (!formData.sections.whatWeOffer.trim()) newErrors['sections.whatWeOffer'] = 'What We Offer section is required';
//     if (!formData.sections.ourProcess.trim()) newErrors['sections.ourProcess'] = 'Our Process section is required';
//     if (!formData.disclaimer.title.trim()) newErrors['disclaimer.title'] = 'Disclaimer title is required';
//     if (!formData.disclaimer.text.trim()) newErrors['disclaimer.text'] = 'Disclaimer text is required';
//     if (!formData.section3.title.trim()) newErrors['section3.title'] = 'Section 3 title is required';

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     setIsSubmitting(true);
//     setErrors({});

//     try {
//       const payload = {
//         language: 'en',
//         hero: {
//           title: formData.hero.title.trim(),
//           subtitle: formData.hero.subtitle.trim(),
//           paragraphs: formData.hero.paragraphs.filter(p => p.trim()).map(p => p.trim())
//         },
//         navigation: {
//           aboutUs: formData.navigation.aboutUs.trim(),
//           ourTeam: formData.navigation.ourTeam.trim()
//         },
//         textBanner: {
//           title: formData.textBanner.title.trim(),
//           paragraphs: formData.textBanner.paragraphs.filter(p => p.trim()).map(p => p.trim())
//         },
//         textBanner2: {
//           title: formData.textBanner2.title.trim(),
//           paragraphs: formData.textBanner2.paragraphs.filter(p => p.trim()).map(p => p.trim())
//         },
//         sections: {
//           whatWeOffer: formData.sections.whatWeOffer.trim(),
//           ourProcess: formData.sections.ourProcess.trim()
//         },
//         offers: formData.offers.filter(o => o.title.trim()).map(o => ({
//           icon: o.icon.trim(),
//           title: o.title.trim(),
//           desc: o.desc.trim()
//         })),
//         process: formData.process.filter(p => p.title.trim()).map(p => ({
//           icon: p.icon.trim(),
//           title: p.title.trim(),
//           desc: p.desc.trim()
//         })),
//         disclaimer: {
//           title: formData.disclaimer.title.trim(),
//           text: formData.disclaimer.text.trim()
//         },
//         section3: {
//           title: formData.section3.title.trim(),
//           paragraphs: formData.section3.paragraphs.filter(p => p.trim()).map(p => p.trim())
//         },
//         spanishData: JSON.stringify({
//           language: 'es',
//           hero: {
//             title: spanishData.hero.title.trim(),
//             subtitle: spanishData.hero.subtitle.trim(),
//             paragraphs: spanishData.hero.paragraphs.filter(p => p.trim()).map(p => p.trim())
//           },
//           navigation: {
//             aboutUs: spanishData.navigation.aboutUs.trim(),
//             ourTeam: spanishData.navigation.ourTeam.trim()
//           },
//           textBanner: {
//             title: spanishData.textBanner.title.trim(),
//             paragraphs: spanishData.textBanner.paragraphs.filter(p => p.trim()).map(p => p.trim())
//           },
//           textBanner2: {
//             title: spanishData.textBanner2.title.trim(),
//             paragraphs: spanishData.textBanner2.paragraphs.filter(p => p.trim()).map(p => p.trim())
//           },
//           sections: {
//             whatWeOffer: spanishData.sections.whatWeOffer.trim(),
//             ourProcess: spanishData.sections.ourProcess.trim()
//           },
//           offers: spanishData.offers.filter(o => o.title.trim()).map(o => ({
//             icon: o.icon.trim(),
//             title: o.title.trim(),
//             desc: o.desc.trim()
//           })),
//           process: spanishData.process.filter(p => p.title.trim()).map(p => ({
//             icon: p.icon.trim(),
//             title: p.title.trim(),
//             desc: p.desc.trim()
//           })),
//           disclaimer: {
//             title: spanishData.disclaimer.title.trim(),
//             text: spanishData.disclaimer.text.trim()
//           },
//           section3: {
//             title: spanishData.section3.title.trim(),
//             paragraphs: spanishData.section3.paragraphs.filter(p => p.trim()).map(p => p.trim())
//           }
//         })
//       };

//       let response;

//       if (isNewContent) {
//         response = await axios.post(`${config.BASE_URL}/api/admin/facade-page`, payload, {
//           withCredentials: true,
//           headers: { "Content-Type": "application/json" }
//         });

//         if (response.status === 201) {
//           setContentId(response.data.data._id);
//           setIsNewContent(false);
//           setSuccessMessage('Facade page created successfully!');
//         }
//       } else {
//         response = await axios.put(`${config.BASE_URL}/api/admin/facade-page/${contentId}`, payload, {
//           withCredentials: true,
//           headers: { "Content-Type": "application/json" }
//         });

//         if (response.status === 200) {
//           setSuccessMessage('Facade page updated successfully!');
//         }
//       }

//       setTimeout(() => setSuccessMessage(''), 3000);

//     } catch (err) {
//       console.error('Error saving facade page:', err);
//       let errorMessage = "Failed to save facade page";
//       if (err.response?.data?.message) errorMessage = err.response.data.message;
//       else if (err.response?.status === 400) errorMessage = "Invalid data provided";
//       else if (err.response?.status === 401) {
//         errorMessage = "Authentication failed. Please login again.";
//         setTimeout(() => navigate('/admin/login'), 2000);
//       }
//       setErrors({ submit: errorMessage });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="dashboard">
//         <div className="container">
//           <div className="main-section">
//             <div className="loading-container">
//               <div className="loading-spinner"></div>
//               <p className="text-white">Loading facade page...</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="dashboard">
//       <div className="container">
//         <h1 className="dash_title">Dashboard</h1>
//         <div className="main-section">
//           <div className="back_btn_wrap">
//             <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
//           </div>
//           <div className="main-inner add_project_main">
//             <h2 style={{ marginBottom: '20px', color: '#fff' }}>
//               {isNewContent ? 'Create Facade Page' : 'Edit Facade Page'}
//             </h2>

//             {/* Language Tabs */}
//             <div className="language-tabs" style={{ marginBottom: '20px' }}>
//               <button 
//                 type="button" 
//                 onClick={() => setActiveLanguage('es')}
//                 style={{
//                   padding: '10px 20px',
//                   backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
//                   color: activeLanguage === 'es' ? 'white' : 'black',
//                   border: '1px solid #ddd',
//                   cursor: 'pointer',
//                   borderRadius: '4px'
//                 }}
//               >
//                 Spanish
//               </button>
//             </div>

//             <form onSubmit={handleSubmit}>
//               {successMessage && (
//                 <div style={{
//                   padding: '12px',
//                   marginBottom: '20px',
//                   backgroundColor: '#d4edda',
//                   border: '1px solid #c3e6cb',
//                   borderRadius: '4px',
//                   color: '#155724'
//                 }}>
//                   {successMessage}
//                 </div>
//               )}

//               {/* English Content */}
//               {activeLanguage === 'en' && (
//                 <div>
//                   <h3 style={{ color: '#fff', marginBottom: '20px' }}>English Content</h3>

//                   {/* Hero Section */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Hero Section</h4>
//                     <div className="add_field titleField">
//                       <h2>Title *</h2>
//                       <input
//                         type="text"
//                         value={formData.hero.title}
//                         onChange={(e) => handleHeroChange('title', e.target.value)}
//                         placeholder="Enter hero title"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       {errors['hero.title'] && <p className="error-text">{errors['hero.title']}</p>}
//                     </div>
//                     <div className="add_field titleField">
//                       <h2>Subtitle *</h2>
//                       <input
//                         type="text"
//                         value={formData.hero.subtitle}
//                         onChange={(e) => handleHeroChange('subtitle', e.target.value)}
//                         placeholder="Enter hero subtitle"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       {errors['hero.subtitle'] && <p className="error-text">{errors['hero.subtitle']}</p>}
//                     </div>
//                     <div>
//                       <h2>Paragraphs *</h2>
//                       {formData.hero.paragraphs.map((para, index) => (
//                         <div key={index} style={{ marginBottom: '10px' }}>
//                           <textarea
//                             value={para}
//                             onChange={(e) => handleHeroParagraphChange(index, e.target.value)}
//                             rows="3"
//                             placeholder={`Hero paragraph ${index + 1}`}
//                             disabled={isSubmitting}
//                           />
//                           {formData.hero.paragraphs.length > 1 && (
//                             <button
//                               type="button"
//                               onClick={() => removeHeroParagraph(index)}
//                               style={{
//                                 marginTop: '5px',
//                                 padding: '5px 15px',
//                                 backgroundColor: '#dc3545',
//                                 color: 'white',
//                                 border: 'none',
//                                 cursor: 'pointer',
//                                 borderRadius: '4px'
//                               }}
//                               disabled={isSubmitting}
//                             >
//                               Remove
//                             </button>
//                           )}
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         onClick={addHeroParagraph}
//                         style={{
//                           padding: '8px 16px',
//                           backgroundColor: '#28a745',
//                           color: 'white',
//                           border: 'none',
//                           cursor: 'pointer',
//                           borderRadius: '4px'
//                         }}
//                         disabled={isSubmitting}
//                       >
//                         + Add Paragraph
//                       </button>
//                     </div>
//                   </div>

//                   {/* Navigation Section */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Navigation</h4>
//                     <div className="add_field titleField">
//                       <h2>About Us *</h2>
//                       <input
//                         type="text"
//                         value={formData.navigation.aboutUs}
//                         onChange={(e) => handleNavigationChange('aboutUs', e.target.value)}
//                         placeholder="About Us navigation text"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       {errors['navigation.aboutUs'] && <p className="error-text">{errors['navigation.aboutUs']}</p>}
//                     </div>
//                     <div className="add_field titleField">
//                       <h2>Our Team *</h2>
//                       <input
//                         type="text"
//                         value={formData.navigation.ourTeam}
//                         onChange={(e) => handleNavigationChange('ourTeam', e.target.value)}
//                         placeholder="Our Team navigation text"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       {errors['navigation.ourTeam'] && <p className="error-text">{errors['navigation.ourTeam']}</p>}
//                     </div>
//                   </div>

//                   {/* Text Banner Section */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Text Banner</h4>
//                     <div className="add_field titleField">
//                       <h2>Title *</h2>
//                       <input
//                         type="text"
//                         value={formData.textBanner.title}
//                         onChange={(e) => handleTextBannerChange('title', e.target.value)}
//                         placeholder="Enter text banner title"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       {errors['textBanner.title'] && <p className="error-text">{errors['textBanner.title']}</p>}
//                     </div>
//                     <div>
//                       <h2>Paragraphs *</h2>
//                       {formData.textBanner.paragraphs.map((para, index) => (
//                         <div key={index} style={{ marginBottom: '10px' }}>
//                           <textarea
//                             value={para}
//                             onChange={(e) => handleTextBannerParagraphChange(index, e.target.value)}
//                             rows="3"
//                             placeholder={`Text banner paragraph ${index + 1}`}
//                             disabled={isSubmitting}
//                           />
//                           {formData.textBanner.paragraphs.length > 1 && (
//                             <button
//                               type="button"
//                               onClick={() => removeTextBannerParagraph(index)}
//                               style={{
//                                 marginTop: '5px',
//                                 padding: '5px 15px',
//                                 backgroundColor: '#dc3545',
//                                 color: 'white',
//                                 border: 'none',
//                                 cursor: 'pointer',
//                                 borderRadius: '4px'
//                               }}
//                               disabled={isSubmitting}
//                             >
//                               Remove
//                             </button>
//                           )}
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         onClick={addTextBannerParagraph}
//                         style={{
//                           padding: '8px 16px',
//                           backgroundColor: '#28a745',
//                           color: 'white',
//                           border: 'none',
//                           cursor: 'pointer',
//                           borderRadius: '4px'
//                         }}
//                         disabled={isSubmitting}
//                       >
//                         + Add Paragraph
//                       </button>
//                     </div>
//                   </div>

//                   {/* Text Banner 2 Section */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Text Banner 2</h4>
//                     <div className="add_field titleField">
//                       <h2>Title *</h2>
//                       <input
//                         type="text"
//                         value={formData.textBanner2.title}
//                         onChange={(e) => handleTextBanner2Change('title', e.target.value)}
//                         placeholder="Enter text banner 2 title"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       {errors['textBanner2.title'] && <p className="error-text">{errors['textBanner2.title']}</p>}
//                     </div>
//                     <div>
//                       <h2>Paragraphs *</h2>
//                       {formData.textBanner2.paragraphs.map((para, index) => (
//                         <div key={index} style={{ marginBottom: '10px' }}>
//                           <textarea
//                             value={para}
//                             onChange={(e) => handleTextBanner2ParagraphChange(index, e.target.value)}
//                             rows="3"
//                             placeholder={`Text banner 2 paragraph ${index + 1}`}
//                             disabled={isSubmitting}
//                           />
//                           {formData.textBanner2.paragraphs.length > 1 && (
//                             <button
//                               type="button"
//                               onClick={() => removeTextBanner2Paragraph(index)}
//                               style={{
//                                 marginTop: '5px',
//                                 padding: '5px 15px',
//                                 backgroundColor: '#dc3545',
//                                 color: 'white',
//                                 border: 'none',
//                                 cursor: 'pointer',
//                                 borderRadius: '4px'
//                               }}
//                               disabled={isSubmitting}
//                             >
//                               Remove
//                             </button>
//                           )}
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         onClick={addTextBanner2Paragraph}
//                         style={{
//                           padding: '8px 16px',
//                           backgroundColor: '#28a745',
//                           color: 'white',
//                           border: 'none',
//                           cursor: 'pointer',
//                           borderRadius: '4px'
//                         }}
//                         disabled={isSubmitting}
//                       >
//                         + Add Paragraph
//                       </button>
//                     </div>
//                   </div>

//                   {/* Sections */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Section Titles</h4>
//                     <div className="add_field titleField">
//                       <h2>What We Offer *</h2>
//                       <input
//                         type="text"
//                         value={formData.sections.whatWeOffer}
//                         onChange={(e) => handleSectionsChange('whatWeOffer', e.target.value)}
//                         placeholder="What We Offer section title"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       {errors['sections.whatWeOffer'] && <p className="error-text">{errors['sections.whatWeOffer']}</p>}
//                     </div>
//                     <div className="add_field titleField">
//                       <h2>Our Process *</h2>
//                       <input
//                         type="text"
//                         value={formData.sections.ourProcess}
//                         onChange={(e) => handleSectionsChange('ourProcess', e.target.value)}
//                         placeholder="Our Process section title"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       {errors['sections.ourProcess'] && <p className="error-text">{errors['sections.ourProcess']}</p>}
//                     </div>
//                   </div>

//                   {/* Offers */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Offers</h4>
//                     {formData.offers.map((offer, index) => (
//                       <div key={index} style={{ marginBottom: '20px', padding: '15px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '6px' }}>
//                         <h5 style={{ color: '#fff', marginBottom: '10px' }}>Offer {index + 1}</h5>
//                         <div className="add_field titleField">
//                           <h2>Icon URL</h2>
//                           <input
//                             type="text"
//                             value={offer.icon}
//                             onChange={(e) => handleOfferChange(index, 'icon', e.target.value)}
//                             placeholder="Icon URL or path"
//                             disabled={isSubmitting}
//                           />
//                         </div>
//                         <div className="add_field titleField">
//                           <h2>Title *</h2>
//                           <input
//                             type="text"
//                             value={offer.title}
//                             onChange={(e) => handleOfferChange(index, 'title', e.target.value)}
//                             placeholder="Offer title"
//                             required
//                             disabled={isSubmitting}
//                           />
//                         </div>
//                         <div className="add_field textareaField">
//                           <h2>Description *</h2>
//                           <textarea
//                             value={offer.desc}
//                             onChange={(e) => handleOfferChange(index, 'desc', e.target.value)}
//                             rows="3"
//                             placeholder="Offer description"
//                             disabled={isSubmitting}
//                           />
//                         </div>
//                         {formData.offers.length > 1 && (
//                           <button
//                             type="button"
//                             onClick={() => removeOffer(index)}
//                             style={{
//                               padding: '5px 15px',
//                               backgroundColor: '#dc3545',
//                               color: 'white',
//                               border: 'none',
//                               cursor: 'pointer',
//                               borderRadius: '4px'
//                             }}
//                             disabled={isSubmitting}
//                           >
//                             Remove Offer
//                           </button>
//                         )}
//                       </div>
//                     ))}
//                     <button
//                       type="button"
//                       onClick={addOffer}
//                       style={{
//                         padding: '8px 16px',
//                         backgroundColor: '#28a745',
//                         color: 'white',
//                         border: 'none',
//                         cursor: 'pointer',
//                         borderRadius: '4px'
//                       }}
//                       disabled={isSubmitting}
//                     >
//                       + Add Offer
//                     </button>
//                   </div>

//                   {/* Process */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Process Steps</h4>
//                     {formData.process.map((proc, index) => (
//                       <div key={index} style={{ marginBottom: '20px', padding: '15px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '6px' }}>
//                         <h5 style={{ color: '#fff', marginBottom: '10px' }}>Step {index + 1}</h5>
//                         <div className="add_field titleField">
//                           <h2>Icon URL</h2>
//                           <input
//                             type="text"
//                             value={proc.icon}
//                             onChange={(e) => handleProcessChange(index, 'icon', e.target.value)}
//                             placeholder="Icon URL or path"
//                             disabled={isSubmitting}
//                           />
//                         </div>
//                         <div className="add_field titleField">
//                           <h2>Title *</h2>
//                           <input
//                             type="text"
//                             value={proc.title}
//                             onChange={(e) => handleProcessChange(index, 'title', e.target.value)}
//                             placeholder="Process title"
//                             required
//                             disabled={isSubmitting}
//                           />
//                         </div>
//                         <div className="add_field textareaField">
//                           <h2>Description *</h2>
//                           <textarea
//                             value={proc.desc}
//                             onChange={(e) => handleProcessChange(index, 'desc', e.target.value)}
//                             rows="3"
//                             placeholder="Process description"
//                             disabled={isSubmitting}
//                           />
//                         </div>
//                         {formData.process.length > 1 && (
//                           <button
//                             type="button"
//                             onClick={() => removeProcess(index)}
//                             style={{
//                               padding: '5px 15px',
//                               backgroundColor: '#dc3545',
//                               color: 'white',
//                               border: 'none',
//                               cursor: 'pointer',
//                               borderRadius: '4px'
//                             }}
//                             disabled={isSubmitting}
//                           >
//                             Remove Step
//                           </button>
//                         )}
//                       </div>
//                     ))}
//                     <button
//                       type="button"
//                       onClick={addProcess}
//                       style={{
//                         padding: '8px 16px',
//                         backgroundColor: '#28a745',
//                         color: 'white',
//                         border: 'none',
//                         cursor: 'pointer',
//                         borderRadius: '4px'
//                       }}
//                       disabled={isSubmitting}
//                     >
//                       + Add Process Step
//                     </button>
//                   </div>

//                   {/* Disclaimer */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Disclaimer</h4>
//                     <div className="add_field titleField">
//                       <h2>Title *</h2>
//                       <input
//                         type="text"
//                         value={formData.disclaimer.title}
//                         onChange={(e) => handleDisclaimerChange('title', e.target.value)}
//                         placeholder="Disclaimer title"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       {errors['disclaimer.title'] && <p className="error-text">{errors['disclaimer.title']}</p>}
//                     </div>
//                     <div className="add_field textareaField">
//                       <h2>Text *</h2>
//                       <textarea
//                         value={formData.disclaimer.text}
//                         onChange={(e) => handleDisclaimerChange('text', e.target.value)}
//                         rows="4"
//                         placeholder="Disclaimer text"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       {errors['disclaimer.text'] && <p className="error-text">{errors['disclaimer.text']}</p>}
//                     </div>
//                   </div>

//                   {/* Section 3 */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Section 3</h4>
//                     <div className="add_field titleField">
//                       <h2>Title *</h2>
//                       <input
//                         type="text"
//                         value={formData.section3.title}
//                         onChange={(e) => handleSection3Change('title', e.target.value)}
//                         placeholder="Section 3 title"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       {errors['section3.title'] && <p className="error-text">{errors['section3.title']}</p>}
//                     </div>
//                     <div>
//                       <h2>Paragraphs *</h2>
//                       {formData.section3.paragraphs.map((para, index) => (
//                         <div key={index} style={{ marginBottom: '10px' }}>
//                           <textarea
//                             value={para}
//                             onChange={(e) => handleSection3ParagraphChange(index, e.target.value)}
//                             rows="3"
//                             placeholder={`Section 3 paragraph ${index + 1}`}
//                             disabled={isSubmitting}
//                           />
//                           {formData.section3.paragraphs.length > 1 && (
//                             <button
//                               type="button"
//                               onClick={() => removeSection3Paragraph(index)}
//                               style={{
//                                 marginTop: '5px',
//                                 padding: '5px 15px',
//                                 backgroundColor: '#dc3545',
//                                 color: 'white',
//                                 border: 'none',
//                                 cursor: 'pointer',
//                                 borderRadius: '4px'
//                               }}
//                               disabled={isSubmitting}
//                             >
//                               Remove
//                             </button>
//                           )}
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         onClick={addSection3Paragraph}
//                         style={{
//                           padding: '8px 16px',
//                           backgroundColor: '#28a745',
//                           color: 'white',
//                           border: 'none',
//                           cursor: 'pointer',
//                           borderRadius: '4px'
//                         }}
//                         disabled={isSubmitting}
//                       >
//                         + Add Paragraph
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Spanish Content - Similar structure */}
//               {activeLanguage === 'es' && (
//                 <div>
//                   <h3 style={{ color: '#fff', marginBottom: '20px' }}>Spanish Content (Contenido en Español)</h3>

//                   {/* Spanish Hero Section */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Sección Hero</h4>
//                     <div className="add_field titleField">
//                       <h2>Título</h2>
//                       <input
//                         type="text"
//                         value={spanishData.hero.title}
//                         onChange={(e) => handleSpanishHeroChange('title', e.target.value)}
//                         placeholder="Ingrese el título del hero"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                     <div className="add_field titleField">
//                       <h2>Subtítulo</h2>
//                       <input
//                         type="text"
//                         value={spanishData.hero.subtitle}
//                         onChange={(e) => handleSpanishHeroChange('subtitle', e.target.value)}
//                         placeholder="Ingrese el subtítulo del hero"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                     <div>
//                       <h2>Párrafos</h2>
//                       {spanishData.hero.paragraphs.map((para, index) => (
//                         <div key={index} style={{ marginBottom: '10px' }}>
//                           <textarea
//                             value={para}
//                             onChange={(e) => handleSpanishHeroParagraphChange(index, e.target.value)}
//                             rows="3"
//                             placeholder={`Párrafo ${index + 1}`}
//                             disabled={isSubmitting}
//                           />
//                           {spanishData.hero.paragraphs.length > 1 && (
//                             <button
//                               type="button"
//                               onClick={() => removeSpanishHeroParagraph(index)}
//                               style={{
//                                 marginTop: '5px',
//                                 padding: '5px 15px',
//                                 backgroundColor: '#dc3545',
//                                 color: 'white',
//                                 border: 'none',
//                                 cursor: 'pointer',
//                                 borderRadius: '4px'
//                               }}
//                               disabled={isSubmitting}
//                             >
//                               Eliminar
//                             </button>
//                           )}
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         onClick={addSpanishHeroParagraph}
//                         style={{
//                           padding: '8px 16px',
//                           backgroundColor: '#28a745',
//                           color: 'white',
//                           border: 'none',
//                           cursor: 'pointer',
//                           borderRadius: '4px'
//                         }}
//                         disabled={isSubmitting}
//                       >
//                         + Agregar Párrafo
//                       </button>
//                     </div>
//                   </div>

//                   {/* Spanish Navigation */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Navegación</h4>
//                     <div className="add_field titleField">
//                       <h2>Sobre Nosotros</h2>
//                       <input
//                         type="text"
//                         value={spanishData.navigation.aboutUs}
//                         onChange={(e) => handleSpanishNavigationChange('aboutUs', e.target.value)}
//                         placeholder="Texto de navegación Sobre Nosotros"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                     <div className="add_field titleField">
//                       <h2>Nuestro Equipo</h2>
//                       <input
//                         type="text"
//                         value={spanishData.navigation.ourTeam}
//                         onChange={(e) => handleSpanishNavigationChange('ourTeam', e.target.value)}
//                         placeholder="Texto de navegación Nuestro Equipo"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                   </div>

//                   {/* Spanish Text Banner */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Banner de Texto</h4>
//                     <div className="add_field titleField">
//                       <h2>Título</h2>
//                       <input
//                         type="text"
//                         value={spanishData.textBanner.title}
//                         onChange={(e) => handleSpanishTextBannerChange('title', e.target.value)}
//                         placeholder="Ingrese el título del banner"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                     <div>
//                       <h2>Párrafos</h2>
//                       {spanishData.textBanner.paragraphs.map((para, index) => (
//                         <div key={index} style={{ marginBottom: '10px' }}>
//                           <textarea
//                             value={para}
//                             onChange={(e) => handleSpanishTextBannerParagraphChange(index, e.target.value)}
//                             rows="3"
//                             placeholder={`Párrafo ${index + 1}`}
//                             disabled={isSubmitting}
//                           />
//                           {spanishData.textBanner.paragraphs.length > 1 && (
//                             <button
//                               type="button"
//                               onClick={() => removeSpanishTextBanner2Paragraph(index)}
//                               style={{
//                                 marginTop: '5px',
//                                 padding: '5px 15px',
//                                 backgroundColor: '#dc3545',
//                                 color: 'white',
//                                 border: 'none',
//                                 cursor: 'pointer',
//                                 borderRadius: '4px'
//                               }}
//                               disabled={isSubmitting}
//                             >
//                               Eliminar
//                             </button>
//                           )}
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         onClick={addSpanishTextBanner2Paragraph}
//                         style={{
//                           padding: '8px 16px',
//                           backgroundColor: '#28a745',
//                           color: 'white',
//                           border: 'none',
//                           cursor: 'pointer',
//                           borderRadius: '4px'
//                         }}
//                         disabled={isSubmitting}
//                       >
//                         + Agregar Párrafo
//                       </button>
//                     </div>
//                   </div>

//                   {/* Spanish Sections */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Títulos de Sección</h4>
//                     <div className="add_field titleField">
//                       <h2>Lo Que Ofrecemos</h2>
//                       <input
//                         type="text"
//                         value={spanishData.sections.whatWeOffer}
//                         onChange={(e) => handleSpanishSectionsChange('whatWeOffer', e.target.value)}
//                         placeholder="Título de sección Lo Que Ofrecemos"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                     <div className="add_field titleField">
//                       <h2>Nuestro Proceso</h2>
//                       <input
//                         type="text"
//                         value={spanishData.sections.ourProcess}
//                         onChange={(e) => handleSpanishSectionsChange('ourProcess', e.target.value)}
//                         placeholder="Título de sección Nuestro Proceso"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                   </div>

//                   {/* Spanish Offers */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Ofertas</h4>
//                     {spanishData.offers.map((offer, index) => (
//                       <div key={index} style={{ marginBottom: '20px', padding: '15px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '6px' }}>
//                         <h5 style={{ color: '#fff', marginBottom: '10px' }}>Oferta {index + 1}</h5>
//                         <div className="add_field titleField">
//                           <h2>URL del Icono</h2>
//                           <input
//                             type="text"
//                             value={offer.icon}
//                             onChange={(e) => handleSpanishOfferChange(index, 'icon', e.target.value)}
//                             placeholder="URL o ruta del icono"
//                             disabled={isSubmitting}
//                           />
//                         </div>
//                         <div className="add_field titleField">
//                           <h2>Título</h2>
//                           <input
//                             type="text"
//                             value={offer.title}
//                             onChange={(e) => handleSpanishOfferChange(index, 'title', e.target.value)}
//                             placeholder="Título de la oferta"
//                             disabled={isSubmitting}
//                           />
//                         </div>
//                         <div className="add_field textareaField">
//                           <h2>Descripción</h2>
//                           <textarea
//                             value={offer.desc}
//                             onChange={(e) => handleSpanishOfferChange(index, 'desc', e.target.value)}
//                             rows="3"
//                             placeholder="Descripción de la oferta"
//                             disabled={isSubmitting}
//                           />
//                         </div>
//                         {spanishData.offers.length > 1 && (
//                           <button
//                             type="button"
//                             onClick={() => removeSpanishOffer(index)}
//                             style={{
//                               padding: '5px 15px',
//                               backgroundColor: '#dc3545',
//                               color: 'white',
//                               border: 'none',
//                               cursor: 'pointer',
//                               borderRadius: '4px'
//                             }}
//                             disabled={isSubmitting}
//                           >
//                             Eliminar Oferta
//                           </button>
//                         )}
//                       </div>
//                     ))}
//                     <button
//                       type="button"
//                       onClick={addSpanishOffer}
//                       style={{
//                         padding: '8px 16px',
//                         backgroundColor: '#28a745',
//                         color: 'white',
//                         border: 'none',
//                         cursor: 'pointer',
//                         borderRadius: '4px'
//                       }}
//                       disabled={isSubmitting}
//                     >
//                       + Agregar Oferta
//                     </button>
//                   </div>

//                   {/* Spanish Process */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Pasos del Proceso</h4>
//                     {spanishData.process.map((proc, index) => (
//                       <div key={index} style={{ marginBottom: '20px', padding: '15px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '6px' }}>
//                         <h5 style={{ color: '#fff', marginBottom: '10px' }}>Paso {index + 1}</h5>
//                         <div className="add_field titleField">
//                           <h2>URL del Icono</h2>
//                           <input
//                             type="text"
//                             value={proc.icon}
//                             onChange={(e) => handleSpanishProcessChange(index, 'icon', e.target.value)}
//                             placeholder="URL o ruta del icono"
//                             disabled={isSubmitting}
//                           />
//                         </div>
//                         <div className="add_field titleField">
//                           <h2>Título</h2>
//                           <input
//                             type="text"
//                             value={proc.title}
//                             onChange={(e) => handleSpanishProcessChange(index, 'title', e.target.value)}
//                             placeholder="Título del proceso"
//                             disabled={isSubmitting}
//                           />
//                         </div>
//                         <div className="add_field textareaField">
//                           <h2>Descripción</h2>
//                           <textarea
//                             value={proc.desc}
//                             onChange={(e) => handleSpanishProcessChange(index, 'desc', e.target.value)}
//                             rows="3"
//                             placeholder="Descripción del proceso"
//                             disabled={isSubmitting}
//                           />
//                         </div>
//                         {spanishData.process.length > 1 && (
//                           <button
//                             type="button"
//                             onClick={() => removeSpanishProcess(index)}
//                             style={{
//                               padding: '5px 15px',
//                               backgroundColor: '#dc3545',
//                               color: 'white',
//                               border: 'none',
//                               cursor: 'pointer',
//                               borderRadius: '4px'
//                             }}
//                             disabled={isSubmitting}
//                           >
//                             Eliminar Paso
//                           </button>
//                         )}
//                       </div>
//                     ))}
//                     <button
//                       type="button"
//                       onClick={addSpanishProcess}
//                       style={{
//                         padding: '8px 16px',
//                         backgroundColor: '#28a745',
//                         color: 'white',
//                         border: 'none',
//                         cursor: 'pointer',
//                         borderRadius: '4px'
//                       }}
//                       disabled={isSubmitting}
//                     >
//                       + Agregar Paso del Proceso
//                     </button>
//                   </div>

//                   {/* Spanish Disclaimer */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Descargo de Responsabilidad</h4>
//                     <div className="add_field titleField">
//                       <h2>Título</h2>
//                       <input
//                         type="text"
//                         value={spanishData.disclaimer.title}
//                         onChange={(e) => handleSpanishDisclaimerChange('title', e.target.value)}
//                         placeholder="Título del descargo"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                     <div className="add_field textareaField">
//                       <h2>Texto</h2>
//                       <textarea
//                         value={spanishData.disclaimer.text}
//                         onChange={(e) => handleSpanishDisclaimerChange('text', e.target.value)}
//                         rows="4"
//                         placeholder="Texto del descargo"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                   </div>

//                   {/* Spanish Section 3 */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Sección 3</h4>
//                     <div className="add_field titleField">
//                       <h2>Título</h2>
//                       <input
//                         type="text"
//                         value={spanishData.section3.title}
//                         onChange={(e) => handleSpanishSection3Change('title', e.target.value)}
//                         placeholder="Título de la sección 3"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                     <div>
//                       <h2>Párrafos</h2>
//                       {spanishData.section3.paragraphs.map((para, index) => (
//                         <div key={index} style={{ marginBottom: '10px' }}>
//                           <textarea
//                             value={para}
//                             onChange={(e) => handleSpanishSection3ParagraphChange(index, e.target.value)}
//                             rows="3"
//                             placeholder={`Párrafo ${index + 1}`}
//                             disabled={isSubmitting}
//                           />
//                           {spanishData.section3.paragraphs.length > 1 && (
//                             <button
//                               type="button"
//                               onClick={() => removeSpanishSection3Paragraph(index)}
//                               style={{
//                                 marginTop: '5px',
//                                 padding: '5px 15px',
//                                 backgroundColor: '#dc3545',
//                                 color: 'white',
//                                 border: 'none',
//                                 cursor: 'pointer',
//                                 borderRadius: '4px'
//                               }}
//                               disabled={isSubmitting}
//                             >
//                               Eliminar
//                             </button>
//                           )}
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         onClick={addSpanishSection3Paragraph}
//                         style={{
//                           padding: '8px 16px',
//                           backgroundColor: '#28a745',
//                           color: 'white',
//                           border: 'none',
//                           cursor: 'pointer',
//                           borderRadius: '4px'
//                         }}
//                         disabled={isSubmitting}
//                       >
//                         + Agregar Párrafo
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               <div className="add_project" style={{ marginTop: '30px' }}>
//                 <button type="submit" disabled={isSubmitting} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <Save className="w-5 h-5" />
//                   {isSubmitting ? 'Guardando...' : isNewContent ? 'Crear Página Facade' : 'Actualizar Página Facade'}
//                 </button>
//               </div>
//             </form>

//             {errors.submit && (
//               <div style={{
//                 padding: '12px',
//                 marginTop: '20px',
//                 backgroundColor: '#f8d7da',
//                 border: '1px solid #f5c6cb',
//                 borderRadius: '4px',
//                 color: '#721c24'
//               }}>
//                 {errors.submit}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FacadePageManage;



import React, { useState, useEffect } from 'react';
import { Save, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import axios from 'axios';

const FacadePageManage = () => {
  const navigate = useNavigate();

  const [activeLanguage, setActiveLanguage] = useState('en');
  const [contentId, setContentId] = useState(null);
  const [isNewContent, setIsNewContent] = useState(false);

  // English (default) form data
  const [formData, setFormData] = useState({
    hero: {
      title: '',
      subtitle: '',
      paragraphs: [''],
    },
    navigation: {
      aboutUs: '',
      ourTeam: '',
    },
    textBanner: {
      title: '',
      paragraphs: [''],
    },
    textBanner2: {
      title: '',
      paragraphs: [''],
    },
    sections: {
      whatWeOffer: '',
      ourProcess: '',
    },
    offers: [{ icon: '', title: '', desc: '' }],
    process: [{ icon: '', title: '', desc: '' }],
    disclaimer: {
      title: '',
      text: '',
    },
    section3: {
      title: '',
      paragraphs: [''],
    },
  });

  // Upload files 
  const [heroVideoFile, setHeroVideoFile] = useState(null);
  const [textBannerImageFile, setTextBannerImageFile] = useState(null);
  const [textBanner2ImageFile, setTextBanner2ImageFile] = useState(null);
  const [textBanner3ImageFile, setTextBanner3ImageFile] = useState(null);

  const [disclaimerVideoFile, setDisclaimerVideoFile] = useState(null);

  // Spanish translation form data
  const [spanishData, setSpanishData] = useState({
    hero: {
      title: '',
      subtitle: '',
      paragraphs: [''],
    },
    navigation: {
      aboutUs: '',
      ourTeam: '',
    },
    textBanner: {
      title: '',
      paragraphs: [''],
    },
    textBanner2: {
      title: '',
      paragraphs: [''],
    },
    sections: {
      whatWeOffer: '',
      ourProcess: '',
    },
    offers: [{ icon: '', title: '', desc: '' }],
    process: [{ icon: '', title: '', desc: '' }],
    disclaimer: {
      title: '',
      text: '',
    },
    section3: {
      title: '',
      paragraphs: [''],
    },
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [existingHeroVideoUrl, setExistingHeroVideoUrl] = useState('');
  const [existingTextBannerImageUrl, setExistingTextBannerImageUrl] = useState('');
  const [existingTextBanner2ImageUrl, setExistingTextBanner2ImageUrl] = useState('');
  const [existingTextBanner3ImageUrl, setExistingTextBanner3ImageUrl] = useState('');

  const [existingDisclaimerVideoUrl, setExistingDisclaimerVideoUrl] = useState('');

  useEffect(() => {
    const fetchHomeBanner = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/api/admin/facade-content?includeSpanish=true`, {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.data && response.data.data && response.data.data.length > 0) {
          const data = response.data.data[0];
          setContentId(data._id);
          setIsNewContent(false);

          setFormData({
            hero: {
              title: data.hero?.title || '',
              subtitle: data.hero?.subtitle || '',
              paragraphs: data.hero?.paragraphs?.length > 0 ? data.hero.paragraphs : [''],
            },
            navigation: {
              aboutUs: data.navigation?.aboutUs || '',
              ourTeam: data.navigation?.ourTeam || '',
            },
            textBanner: {
              title: data.textBanner?.title || '',
              paragraphs: data.textBanner?.paragraphs?.length > 0 ? data.textBanner.paragraphs : [''],
            },
            textBanner2: {
              title: data.textBanner2?.title || '',
              paragraphs: data.textBanner2?.paragraphs?.length > 0 ? data.textBanner2.paragraphs : [''],
            },
            sections: {
              whatWeOffer: data.sections?.whatWeOffer || '',
              ourProcess: data.sections?.ourProcess || '',
            },
            offers: data.offers?.length > 0 ? data.offers : [{ icon: '', title: '', desc: '' }],
            process: data.process?.length > 0 ? data.process : [{ icon: '', title: '', desc: '' }],
            disclaimer: {
              title: data.disclaimer?.title || '',
              text: data.disclaimer?.text || '',
            },
            section3: {
              title: data.section3?.title || '',
              paragraphs: data.section3?.paragraphs?.length > 0 ? data.section3.paragraphs : [''],
            },
          });

          // Existing media URLs for preview
          setExistingHeroVideoUrl(data.hero?.vedioUrl || '');
          setExistingTextBannerImageUrl(data.textBanner?.ImageUrl || '');
          setExistingTextBanner2ImageUrl(data.textBanner2?.ImageUrl || '');
          setExistingTextBanner3ImageUrl(data.section3?.ImageUrl || '');

          setExistingDisclaimerVideoUrl(data.disclaimer?.VideoUrl || '');

          setSpanishData({
            hero: {
              title: data.spanishData?.hero?.title || '',
              subtitle: data.spanishData?.hero?.subtitle || '',
              paragraphs: data.spanishData?.hero?.paragraphs?.length > 0 ? data.spanishData.hero.paragraphs : [''],
            },
            navigation: {
              aboutUs: data.spanishData?.navigation?.aboutUs || '',
              ourTeam: data.spanishData?.navigation?.ourTeam || '',
            },
            textBanner: {
              title: data.spanishData?.textBanner?.title || '',
              paragraphs: data.spanishData?.textBanner?.paragraphs?.length > 0 ? data.spanishData.textBanner.paragraphs : [''],
            },
            textBanner2: {
              title: data.spanishData?.textBanner2?.title || '',
              paragraphs: data.spanishData?.textBanner2?.paragraphs?.length > 0 ? data.spanishData.textBanner2.paragraphs : [''],
            },
            sections: {
              whatWeOffer: data.spanishData?.sections?.whatWeOffer || '',
              ourProcess: data.spanishData?.sections?.ourProcess || '',
            },
            offers: data.spanishData?.offers?.length > 0 ? data.spanishData.offers : [{ icon: '', title: '', desc: '' }],
            process: data.spanishData?.process?.length > 0 ? data.spanishData.process : [{ icon: '', title: '', desc: '' }],
            disclaimer: {
              title: data.spanishData?.disclaimer?.title || '',
              text: data.spanishData?.disclaimer?.text || '',
            },
            section3: {
              title: data.spanishData?.section3?.title || '',
              paragraphs: data.spanishData?.section3?.paragraphs?.length > 0 ? data.spanishData.section3.paragraphs : [''],
            },
          });
        } else {
          setIsNewContent(true);
        }
      } catch (err) {
        console.error('Error fetching home banner:', err);
        if (err.response?.status === 404 || err.response?.status === 400) {
          setIsNewContent(true);
        } else if (err.response?.status === 401) {
          setErrors({ submit: 'Authentication failed. Please login again.' });
          setTimeout(() => navigate('/admin/login'), 2000);
        } else {
          setErrors({ submit: 'Failed to fetch home banner details' });
        }
      } finally {
        setLoading(false);
      }
    };

    fetchHomeBanner();
  }, [navigate]);

  // English Handlers
  const handleHeroChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      hero: { ...prev.hero, [field]: value },
    }));
  };

  const handleHeroParagraphChange = (index, value) => {
    const newParagraphs = [...formData.hero.paragraphs];
    newParagraphs[index] = value;
    setFormData(prev => ({
      ...prev,
      hero: { ...prev.hero, paragraphs: newParagraphs },
    }));
  };

  const addHeroParagraph = () => {
    setFormData(prev => ({
      ...prev,
      hero: { ...prev.hero, paragraphs: [...prev.hero.paragraphs, ''] },
    }));
  };

  const removeHeroParagraph = (index) => {
    if (formData.hero.paragraphs.length > 1) {
      const newParagraphs = formData.hero.paragraphs.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        hero: { ...prev.hero, paragraphs: newParagraphs },
      }));
    }
  };

  const handleNavigationChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      navigation: { ...prev.navigation, [field]: value },
    }));
  };

  const handleTextBannerChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      textBanner: { ...prev.textBanner, [field]: value },
    }));
  };

  const handleTextBannerParagraphChange = (index, value) => {
    const newParagraphs = [...formData.textBanner.paragraphs];
    newParagraphs[index] = value;
    setFormData(prev => ({
      ...prev,
      textBanner: { ...prev.textBanner, paragraphs: newParagraphs },
    }));
  };

  const addTextBannerParagraph = () => {
    setFormData(prev => ({
      ...prev,
      textBanner: { ...prev.textBanner, paragraphs: [...prev.textBanner.paragraphs, ''] },
    }));
  };

  const removeTextBannerParagraph = (index) => {
    if (formData.textBanner.paragraphs.length > 1) {
      const newParagraphs = formData.textBanner.paragraphs.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        textBanner: { ...prev.textBanner, paragraphs: newParagraphs },
      }));
    }
  };

  const handleTextBanner2Change = (field, value) => {
    setFormData(prev => ({
      ...prev,
      textBanner2: { ...prev.textBanner2, [field]: value },
    }));
  };

  const handleTextBanner2ParagraphChange = (index, value) => {
    const newParagraphs = [...formData.textBanner2.paragraphs];
    newParagraphs[index] = value;
    setFormData(prev => ({
      ...prev,
      textBanner2: { ...prev.textBanner2, paragraphs: newParagraphs },
    }));
  };

  const addTextBanner2Paragraph = () => {
    setFormData(prev => ({
      ...prev,
      textBanner2: { ...prev.textBanner2, paragraphs: [...prev.textBanner2.paragraphs, ''] },
    }));
  };

  const removeTextBanner2Paragraph = (index) => {
    if (formData.textBanner2.paragraphs.length > 1) {
      const newParagraphs = formData.textBanner2.paragraphs.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        textBanner2: { ...prev.textBanner2, paragraphs: newParagraphs },
      }));
    }
  };

  const handleSectionsChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      sections: { ...prev.sections, [field]: value },
    }));
  };

  const handleOfferChange = (index, field, value) => {
    const newOffers = [...formData.offers];
    newOffers[index] = { ...newOffers[index], [field]: value };
    setFormData(prev => ({ ...prev, offers: newOffers }));
  };

  const addOffer = () => {
    setFormData(prev => ({
      ...prev,
      offers: [...prev.offers, { icon: '', title: '', desc: '' }],
    }));
  };

  const removeOffer = (index) => {
    if (formData.offers.length > 1) {
      const newOffers = formData.offers.filter((_, i) => i !== index);
      setFormData(prev => ({ ...prev, offers: newOffers }));
    }
  };

  const handleProcessChange = (index, field, value) => {
    const newProcess = [...formData.process];
    newProcess[index] = { ...newProcess[index], [field]: value };
    setFormData(prev => ({ ...prev, process: newProcess }));
  };

  const addProcess = () => {
    setFormData(prev => ({
      ...prev,
      process: [...prev.process, { icon: '', title: '', desc: '' }],
    }));
  };

  const removeProcess = (index) => {
    if (formData.process.length > 1) {
      const newProcess = formData.process.filter((_, i) => i !== index);
      setFormData(prev => ({ ...prev, process: newProcess }));
    }
  };

  const handleDisclaimerChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      disclaimer: { ...prev.disclaimer, [field]: value },
    }));
  };

  const handleSection3Change = (field, value) => {
    setFormData(prev => ({
      ...prev,
      section3: { ...prev.section3, [field]: value },
    }));
  };

  const handleSection3ParagraphChange = (index, value) => {
    const newParagraphs = [...formData.section3.paragraphs];
    newParagraphs[index] = value;
    setFormData(prev => ({
      ...prev,
      section3: { ...prev.section3, paragraphs: newParagraphs },
    }));
  };

  const addSection3Paragraph = () => {
    setFormData(prev => ({
      ...prev,
      section3: { ...prev.section3, paragraphs: [...prev.section3.paragraphs, ''] },
    }));
  };

  const removeSection3Paragraph = (index) => {
    if (formData.section3.paragraphs.length > 1) {
      const newParagraphs = formData.section3.paragraphs.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        section3: { ...prev.section3, paragraphs: newParagraphs },
      }));
    }
  };

  // Spanish Handlers
  const handleSpanishHeroChange = (field, value) => {
    setSpanishData(prev => ({
      ...prev,
      hero: { ...prev.hero, [field]: value },
    }));
  };

  const handleSpanishHeroParagraphChange = (index, value) => {
    const newParagraphs = [...spanishData.hero.paragraphs];
    newParagraphs[index] = value;
    setSpanishData(prev => ({
      ...prev,
      hero: { ...prev.hero, paragraphs: newParagraphs },
    }));
  };

  const addSpanishHeroParagraph = () => {
    setSpanishData(prev => ({
      ...prev,
      hero: { ...prev.hero, paragraphs: [...prev.hero.paragraphs, ''] },
    }));
  };

  const removeSpanishHeroParagraph = (index) => {
    if (spanishData.hero.paragraphs.length > 1) {
      const newParagraphs = spanishData.hero.paragraphs.filter((_, i) => i !== index);
      setSpanishData(prev => ({
        ...prev,
        hero: { ...prev.hero, paragraphs: newParagraphs },
      }));
    }
  };

  const handleSpanishNavigationChange = (field, value) => {
    setSpanishData(prev => ({
      ...prev,
      navigation: { ...prev.navigation, [field]: value },
    }));
  };

  const handleSpanishTextBannerChange = (field, value) => {
    setSpanishData(prev => ({
      ...prev,
      textBanner: { ...prev.textBanner, [field]: value },
    }));
  };

  const handleSpanishTextBannerParagraphChange = (index, value) => {
    const newParagraphs = [...spanishData.textBanner.paragraphs];
    newParagraphs[index] = value;
    setSpanishData(prev => ({
      ...prev,
      textBanner: { ...prev.textBanner, paragraphs: newParagraphs },
    }));
  };

  const addSpanishTextBannerParagraph = () => {
    setSpanishData(prev => ({
      ...prev,
      textBanner: { ...prev.textBanner, paragraphs: [...prev.textBanner.paragraphs, ''] },
    }));
  };

  const removeSpanishTextBannerParagraph = (index) => {
    if (spanishData.textBanner.paragraphs.length > 1) {
      const newParagraphs = spanishData.textBanner.paragraphs.filter((_, i) => i !== index);
      setSpanishData(prev => ({
        ...prev,
        textBanner: { ...prev.textBanner, paragraphs: newParagraphs },
      }));
    }
  };

  const handleSpanishTextBanner2Change = (field, value) => {
    setSpanishData(prev => ({
      ...prev,
      textBanner2: { ...prev.textBanner2, [field]: value },
    }));
  };

  const handleSpanishTextBanner2ParagraphChange = (index, value) => {
    const newParagraphs = [...spanishData.textBanner2.paragraphs];
    newParagraphs[index] = value;
    setSpanishData(prev => ({
      ...prev,
      textBanner2: { ...prev.textBanner2, paragraphs: newParagraphs },
    }));
  };

  const addSpanishTextBanner2Paragraph = () => {
    setSpanishData(prev => ({
      ...prev,
      textBanner2: { ...prev.textBanner2, paragraphs: [...prev.textBanner2.paragraphs, ''] },
    }));
  };

  const removeSpanishTextBanner2Paragraph = (index) => {
    if (spanishData.textBanner2.paragraphs.length > 1) {
      const newParagraphs = spanishData.textBanner2.paragraphs.filter((_, i) => i !== index);
      setSpanishData(prev => ({
        ...prev,
        textBanner2: { ...prev.textBanner2, paragraphs: newParagraphs },
      }));
    }
  };

  const handleSpanishSectionsChange = (field, value) => {
    setSpanishData(prev => ({
      ...prev,
      sections: { ...prev.sections, [field]: value },
    }));
  };

  const handleSpanishOfferChange = (index, field, value) => {
    const newOffers = [...spanishData.offers];
    newOffers[index] = { ...newOffers[index], [field]: value };
    setSpanishData(prev => ({ ...prev, offers: newOffers }));
  };

  const addSpanishOffer = () => {
    setSpanishData(prev => ({
      ...prev,
      offers: [...prev.offers, { icon: '', title: '', desc: '' }],
    }));
  };

  const removeSpanishOffer = (index) => {
    if (spanishData.offers.length > 1) {
      const newOffers = spanishData.offers.filter((_, i) => i !== index);
      setSpanishData(prev => ({ ...prev, offers: newOffers }));
    }
  };

  const handleSpanishProcessChange = (index, field, value) => {
    const newProcess = [...spanishData.process];
    newProcess[index] = { ...newProcess[index], [field]: value };
    setSpanishData(prev => ({ ...prev, process: newProcess }));
  };

  const addSpanishProcess = () => {
    setSpanishData(prev => ({
      ...prev,
      process: [...prev.process, { icon: '', title: '', desc: '' }],
    }));
  };

  const removeSpanishProcess = (index) => {
    if (spanishData.process.length > 1) {
      const newProcess = spanishData.process.filter((_, i) => i !== index);
      setSpanishData(prev => ({ ...prev, process: newProcess }));
    }
  };

  const handleSpanishDisclaimerChange = (field, value) => {
    setSpanishData(prev => ({
      ...prev,
      disclaimer: { ...prev.disclaimer, [field]: value },
    }));
  };

  const handleSpanishSection3Change = (field, value) => {
    setSpanishData(prev => ({
      ...prev,
      section3: { ...prev.section3, [field]: value },
    }));
  };

  const handleSpanishSection3ParagraphChange = (index, value) => {
    const newParagraphs = [...spanishData.section3.paragraphs];
    newParagraphs[index] = value;
    setSpanishData(prev => ({
      ...prev,
      section3: { ...prev.section3, paragraphs: newParagraphs },
    }));
  };

  const addSpanishSection3Paragraph = () => {
    setSpanishData(prev => ({
      ...prev,
      section3: { ...prev.section3, paragraphs: [...prev.section3.paragraphs, ''] },
    }));
  };

  const removeSpanishSection3Paragraph = (index) => {
    if (spanishData.section3.paragraphs.length > 1) {
      const newParagraphs = spanishData.section3.paragraphs.filter((_, i) => i !== index);
      setSpanishData(prev => ({
        ...prev,
        section3: { ...prev.section3, paragraphs: newParagraphs },
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // if (!formData.hero.title.trim()) newErrors['hero.title'] = 'Hero title is required';
    // if (!formData.hero.subtitle.trim()) newErrors['hero.subtitle'] = 'Hero subtitle is required';
    // if (!formData.navigation.aboutUs.trim()) newErrors['navigation.aboutUs'] = 'About Us navigation is required';
    // if (!formData.navigation.ourTeam.trim()) newErrors['navigation.ourTeam'] = 'Our Team navigation is required';
    // if (!formData.textBanner.title.trim()) newErrors['textBanner.title'] = 'Text Banner title is required';
    // if (!formData.textBanner2.title.trim()) newErrors['textBanner2.title'] = 'Text Banner 2 title is required';
    // if (!formData.sections.whatWeOffer.trim()) newErrors['sections.whatWeOffer'] = 'What We Offer section is required';
    // if (!formData.sections.ourProcess.trim()) newErrors['sections.ourProcess'] = 'Our Process section is required';
    // if (!formData.disclaimer.title.trim()) newErrors['disclaimer.title'] = 'Disclaimer title is required';
    // if (!formData.disclaimer.text.trim()) newErrors['disclaimer.text'] = 'Disclaimer text is required';
    // if (!formData.section3.title.trim()) newErrors['section3.title'] = 'Section 3 title is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsSubmitting(true);
    setErrors({});

    try {
      const fd = new FormData();

      fd.append('hero', JSON.stringify({
        title: formData.hero.title.trim(),
        subtitle: formData.hero.subtitle.trim(),
        paragraphs: formData.hero.paragraphs.filter(p => p.trim()).map(p => p.trim()),
      }));

      fd.append('textBanner', JSON.stringify({
        title: formData.textBanner.title.trim(),
        paragraphs: formData.textBanner.paragraphs.filter(p => p.trim()).map(p => p.trim()),
      }));

      fd.append('textBanner2', JSON.stringify({
        title: formData.textBanner2.title.trim(),
        paragraphs: formData.textBanner2.paragraphs.filter(p => p.trim()).map(p => p.trim()),
      }));

      fd.append('disclaimer', JSON.stringify({
        title: formData.disclaimer.title.trim(),
        text: formData.disclaimer.text.trim(),
      }));

      fd.append('section3', JSON.stringify({
        title: formData.section3.title.trim(),
        paragraphs: formData.section3.paragraphs.filter(p => p.trim()).map(p => p.trim()),
      }));

      // Optional Spanish translation
      fd.append('spanishData', JSON.stringify({
        hero: {
          title: spanishData.hero.title.trim(),
          subtitle: spanishData.hero.subtitle.trim(),
          paragraphs: spanishData.hero.paragraphs.filter(p => p.trim()).map(p => p.trim()),
        },
        textBanner: {
          title: spanishData.textBanner.title.trim(),
          paragraphs: spanishData.textBanner.paragraphs.filter(p => p.trim()).map(p => p.trim()),
        },
        textBanner2: {
          title: spanishData.textBanner2.title.trim(),
          paragraphs: spanishData.textBanner2.paragraphs.filter(p => p.trim()).map(p => p.trim()),
        },
        disclaimer: {
          title: spanishData.disclaimer.title.trim(),
          text: spanishData.disclaimer.text.trim(),
        },
        section3: {
          title: spanishData.section3.title.trim(),
          paragraphs: spanishData.section3.paragraphs.filter(p => p.trim()).map(p => p.trim()),
        },
      }));

      // Files 
      if (heroVideoFile) fd.append('heroVideo', heroVideoFile);
      if (textBannerImageFile) fd.append('textBannerImage', textBannerImageFile);
      if (textBanner2ImageFile) fd.append('textBanner2Image', textBanner2ImageFile);

      if (textBanner3ImageFile) fd.append('section3Image', textBanner3ImageFile);
      if (disclaimerVideoFile) fd.append('disclaimerVideo', disclaimerVideoFile);

      let response;

      if (isNewContent) {
        response = await axios.post(`${config.BASE_URL}/api/admin/facade-content`, fd, {
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.status === 201) {
          setContentId(response.data.data._id);
          setIsNewContent(false);
          setSuccessMessage('Facade content created successfully!');
          const saved = response.data.data;
          setExistingHeroVideoUrl(saved?.hero?.vedioUrl || '');
          setExistingTextBannerImageUrl(saved?.textBanner?.ImageUrl || '');
          setExistingTextBanner2ImageUrl(saved?.textBanner2?.ImageUrl || '');
          setExistingTextBanner3ImageUrl(saved?.section3?.ImageUrl || '');

          setExistingDisclaimerVideoUrl(saved?.disclaimer?.VideoUrl || '');
        }
      } else {
        response = await axios.put(`${config.BASE_URL}/api/admin/facade-content/${contentId}`, fd, {
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.status === 200) {
          setSuccessMessage('Facade content updated successfully!');
          const saved = response.data.data;
          setExistingHeroVideoUrl(saved?.hero?.vedioUrl || '');
          setExistingTextBannerImageUrl(saved?.textBanner?.ImageUrl || '');
          setExistingTextBanner2ImageUrl(saved?.textBanner2?.ImageUrl || '');
          setExistingTextBanner3ImageUrl(saved?.section3?.ImageUrl || '');

          setExistingDisclaimerVideoUrl(saved?.disclaimer?.VideoUrl || '');
        }
      }

      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (err) {
      console.error('Error saving home banner:', err);
      let errorMessage = 'Failed to save home banner';
      if (err.response?.data?.message) errorMessage = err.response.data.message;
      else if (err.response?.status === 400) errorMessage = 'Invalid data provided';
      else if (err.response?.status === 401) {
        errorMessage = 'Authentication failed. Please login again.';
        setTimeout(() => navigate('/admin/login'), 2000);
      }
      setErrors({ submit: errorMessage });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="dashboard">
        <div className="container">
          <div className="main-section">
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p className="text-white">Loading home banner...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="container">
        <h1 className="dash_title">Lighighting Facade Data</h1>
        <div className="main-section">
          <div className="back_btn_wrap">
            <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
          </div>
          <div className="main-inner add_project_main">
            {/* <h2 style={{ marginBottom: '20px', color: '#fff' }}>
              {isNewContent ? 'Create Home Banner' : 'Edit Home Banner'}
            </h2> */}

            {/* Language Tabs */}
            <div className="language-tabs" style={{ marginBottom: '20px' }}>
              <button
                type="button"
                onClick={() => setActiveLanguage('en')}
                style={{
                  padding: '10px 20px',
                  marginRight: '10px',
                  backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'en' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer',
                  borderRadius: '4px',
                }}
              >
                English
              </button>
              <button
                type="button"
                onClick={() => setActiveLanguage('es')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'es' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer',
                  borderRadius: '4px',
                }}
              >
                Spanish
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              {successMessage && (
                <div
                  style={{
                    padding: '12px',
                    marginBottom: '20px',
                    backgroundColor: '#d4edda',
                    border: '1px solid #c3e6cb',
                    borderRadius: '4px',
                    color: '#155724',
                  }}
                >
                  {successMessage}
                </div>
              )}

              {/* English Content */}
              {activeLanguage === 'en' && (
                <div>
                  <h3 style={{ color: '#fff', marginBottom: '20px' }}>English Content</h3>

                  {/* Hero Section */}
                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Banner 1</h4>
                    <div className="add_field titleField">
                      <h2>Title *</h2>
                      <input
                        type="text"
                        value={formData.hero.title}
                        onChange={(e) => handleHeroChange('title', e.target.value)}
                        placeholder="Enter hero title"
                        required
                        disabled={isSubmitting}
                      />
                      {errors['hero.title'] && <p className="error-text">{errors['hero.title']}</p>}
                    </div>
                    <div className="add_field titleField">
                      <h2>Subtitle *</h2>
                      <input
                        type="text"
                        value={formData.hero.subtitle}
                        onChange={(e) => handleHeroChange('subtitle', e.target.value)}
                        placeholder="Enter hero subtitle"
                        required
                        disabled={isSubmitting}
                      />
                      {errors['hero.subtitle'] && <p className="error-text">{errors['hero.subtitle']}</p>}
                    </div>
                    <div>
                      <h2>Paragraphs *</h2>
                      {formData.hero.paragraphs.map((para, index) => (
                        <div key={index} style={{ marginBottom: '10px' }} className="add_field titleField">
                          <textarea
                            value={para}
                            onChange={(e) => handleHeroParagraphChange(index, e.target.value)}
                            rows="3"
                            placeholder={`Hero paragraph ${index + 1}`}
                            disabled={isSubmitting}
                          />
                          {formData.hero.paragraphs.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeHeroParagraph(index)}
                              style={{
                                marginTop: '5px',
                                padding: '5px 15px',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '4px',
                              }}
                              disabled={isSubmitting}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={addHeroParagraph}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                          borderRadius: '4px',
                        }}
                        disabled={isSubmitting}
                      >
                        + Add Paragraph
                      </button>
                    </div>
                    <div className="add_field titleField">
                      <h2>Hero Video </h2>
                      <input
                        type="file"
                        onChange={(e) => setHeroVideoFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
                        disabled={isSubmitting}
                      />
                      {(heroVideoFile || existingHeroVideoUrl) && (
                        <div style={{ marginTop: '10px' }} className='wid-150'>
                          <video
                            controls
                            src={heroVideoFile ? URL.createObjectURL(heroVideoFile) : config.BASE_URL + '/' + existingHeroVideoUrl}
                            style={{ maxWidth: '100%', height: 'auto' }}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Navigation</h4>
                    <div className="add_field titleField">
                      <h2>About Us *</h2>
                      <input
                        type="text"
                        value={formData.navigation.aboutUs}
                        onChange={(e) => handleNavigationChange('aboutUs', e.target.value)}
                        placeholder="About Us navigation text"
                        required
                        disabled={isSubmitting}
                      />
                      {errors['navigation.aboutUs'] && <p className="error-text">{errors['navigation.aboutUs']}</p>}
                    </div>
                    <div className="add_field titleField">
                      <h2>Our Team *</h2>
                      <input
                        type="text"
                        value={formData.navigation.ourTeam}
                        onChange={(e) => handleNavigationChange('ourTeam', e.target.value)}
                        placeholder="Our Team navigation text"
                        required
                        disabled={isSubmitting}
                      />
                      {errors['navigation.ourTeam'] && <p className="error-text">{errors['navigation.ourTeam']}</p>}
                    </div>
                  </div> */}

                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Banner 2</h4>
                    <div className="add_field titleField">
                      <h2>Title *</h2>
                      <input
                        type="text"
                        value={formData.textBanner.title}
                        onChange={(e) => handleTextBannerChange('title', e.target.value)}
                        placeholder="Enter text banner title"
                        required
                        disabled={isSubmitting}
                      />
                      {errors['textBanner.title'] && <p className="error-text">{errors['textBanner.title']}</p>}
                    </div>
                    <div>
                      <h2>Paragraphs *</h2>
                      {formData.textBanner.paragraphs.map((para, index) => (
                        <div key={index} className="add_field titleField" style={{ marginBottom: '10px' }}>
                          <textarea
                            value={para}
                            onChange={(e) => handleTextBannerParagraphChange(index, e.target.value)}
                            rows="3"
                            placeholder={`Text banner paragraph ${index + 1}`}
                            disabled={isSubmitting}
                          />
                          {formData.textBanner.paragraphs.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeTextBannerParagraph(index)}
                              style={{
                                marginTop: '5px',
                                padding: '5px 15px',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '4px',
                              }}
                              disabled={isSubmitting}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={addTextBannerParagraph}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                          borderRadius: '4px',
                        }}
                        disabled={isSubmitting}
                      >
                        + Add Paragraph
                      </button>
                    </div>
                    <div className="add_field titleField">
                      <h2>Banner 2 Image </h2>
                      <input
                        type="file"
                        onChange={(e) => setTextBannerImageFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
                        disabled={isSubmitting}
                      />
                      {(textBannerImageFile || existingTextBannerImageUrl) && (
                        <div style={{ marginTop: '10px' }} className='wid-150'>
                          <img
                            alt="Banner 2"
                            src={textBannerImageFile ? URL.createObjectURL(textBannerImageFile) : config.BASE_URL + '/' + existingTextBannerImageUrl}
                            style={{ maxWidth: '100%', height: 'auto' }}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Text Banner 2 Section */}


                  {/* Sections */}
                  {/* <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Section Titles</h4>
                    <div className="add_field titleField">
                      <h2>What We Offer *</h2>
                      <input
                        type="text"
                        value={formData.sections.whatWeOffer}
                        onChange={(e) => handleSectionsChange('whatWeOffer', e.target.value)}
                        placeholder="What We Offer section title"
                        required
                        disabled={isSubmitting}
                      />
                      {errors['sections.whatWeOffer'] && <p className="error-text">{errors['sections.whatWeOffer']}</p>}
                    </div>
                    <div className="add_field titleField">
                      <h2>Our Process *</h2>
                      <input
                        type="text"
                        value={formData.sections.ourProcess}
                        onChange={(e) => handleSectionsChange('ourProcess', e.target.value)}
                        placeholder="Our Process section title"
                        required
                        disabled={isSubmitting}
                      />
                      {errors['sections.ourProcess'] && <p className="error-text">{errors['sections.ourProcess']}</p>}
                    </div>
                  </div> */}

                  {/* <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Offers</h4>
                    {formData.offers.map((offer, index) => (
                      <div key={index} style={{ marginBottom: '20px', padding: '15px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '6px' }}>
                        <h5 style={{ color: '#fff', marginBottom: '10px' }}>Offer {index + 1}</h5>
                        <div className="add_field titleField">
                          <h2>Icon URL</h2>
                          <input
                            type="text"
                            value={offer.icon}
                            onChange={(e) => handleOfferChange(index, 'icon', e.target.value)}
                            placeholder="Icon URL or path"
                            disabled={isSubmitting}
                          />
                        </div>
                        <div className="add_field titleField">
                          <h2>Title *</h2>
                          <input
                            type="text"
                            value={offer.title}
                            onChange={(e) => handleOfferChange(index, 'title', e.target.value)}
                            placeholder="Offer title"
                            required
                            disabled={isSubmitting}
                          />
                        </div>
                        <div className="add_field textareaField">
                          <h2>Description *</h2>
                          <textarea
                            value={offer.desc}
                            onChange={(e) => handleOfferChange(index, 'desc', e.target.value)}
                            rows="3"
                            placeholder="Offer description"
                            disabled={isSubmitting}
                          />
                        </div>
                        {formData.offers.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removeOffer(index)}
                            style={{
                              padding: '5px 15px',
                              backgroundColor: '#dc3545',
                              color: 'white',
                              border: 'none',
                              cursor: 'pointer',
                              borderRadius: '4px',
                            }}
                            disabled={isSubmitting}
                          >
                            Remove Offer
                          </button>
                        )}
                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={addOffer}
                      style={{
                        padding: '8px 16px',
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        borderRadius: '4px',
                      }}
                      disabled={isSubmitting}
                    >
                      + Add Offer
                    </button>
                  </div> */}
                  {/* <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Process Steps</h4>
                    {formData.process.map((proc, index) => (
                      <div key={index} style={{ marginBottom: '20px', padding: '15px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '6px' }}>
                        <h5 style={{ color: '#fff', marginBottom: '10px' }}>Step {index + 1}</h5>
                        <div className="add_field titleField">
                          <h2>Icon URL</h2>
                          <input
                            type="text"
                            value={proc.icon}
                            onChange={(e) => handleProcessChange(index, 'icon', e.target.value)}
                            placeholder="Icon URL or path"
                            disabled={isSubmitting}
                          />
                        </div>
                        <div className="add_field titleField">
                          <h2>Title *</h2>
                          <input
                            type="text"
                            value={proc.title}
                            onChange={(e) => handleProcessChange(index, 'title', e.target.value)}
                            placeholder="Process title"
                            required
                            disabled={isSubmitting}
                          />
                        </div>
                        <div className="add_field textareaField">
                          <h2>Description *</h2>
                          <textarea
                            value={proc.desc}
                            onChange={(e) => handleProcessChange(index, 'desc', e.target.value)}
                            rows="3"
                            placeholder="Process description"
                            disabled={isSubmitting}
                          />
                        </div>
                        {formData.process.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removeProcess(index)}
                            style={{
                              padding: '5px 15px',
                              backgroundColor: '#dc3545',
                              color: 'white',
                              border: 'none',
                              cursor: 'pointer',
                              borderRadius: '4px',
                            }}
                            disabled={isSubmitting}
                          >
                            Remove Step
                          </button>
                        )}
                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={addProcess}
                      style={{
                        padding: '8px 16px',
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        borderRadius: '4px',
                      }}
                      disabled={isSubmitting}
                    >
                      + Add Process Step
                    </button>
                  </div> */}



                  {/* Section 3 */}
                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Banner 3</h4>
                    <div className="add_field titleField">
                      <h2>Title *</h2>
                      <input
                        type="text"
                        value={formData.section3.title}
                        onChange={(e) => handleSection3Change('title', e.target.value)}
                        placeholder="Section 3 title"
                        required
                        disabled={isSubmitting}
                      />
                      {errors['section3.title'] && <p className="error-text">{errors['section3.title']}</p>}
                    </div>
                    <div>
                      <h2>Paragraphs *</h2>
                      {formData.section3.paragraphs.map((para, index) => (
                        <div key={index} style={{ marginBottom: '10px' }} className="add_field titleField">
                          <textarea
                            value={para}
                            onChange={(e) => handleSection3ParagraphChange(index, e.target.value)}
                            rows="3"
                            placeholder={`Section 3 paragraph ${index + 1}`}
                            disabled={isSubmitting}
                          />
                          {formData.section3.paragraphs.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeSection3Paragraph(index)}
                              style={{
                                marginTop: '5px',
                                padding: '5px 15px',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '4px',
                              }}
                              disabled={isSubmitting}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={addSection3Paragraph}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                          borderRadius: '4px',
                        }}
                        disabled={isSubmitting}
                      >
                        + Add Paragraph
                      </button>
                    </div>
                    <div className="add_field titleField">
                      <h2>Banner 3 Image </h2>
                      <input
                        type="file"
                        onChange={(e) => setTextBanner3ImageFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
                        disabled={isSubmitting}
                      />
                      {(textBanner3ImageFile || existingTextBanner3ImageUrl) && (
                        <div style={{ marginTop: '10px' }} className='wid-150'>
                          <img
                            alt="Banner 3"
                            src={textBanner3ImageFile ? URL.createObjectURL(textBanner3ImageFile) : config.BASE_URL + '/' + existingTextBanner3ImageUrl}
                            style={{ maxWidth: '100%', height: 'auto' }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Banner 4</h4>
                    <div className="add_field titleField">
                      <h2>Title *</h2>
                      <input
                        type="text"
                        value={formData.textBanner2.title}
                        onChange={(e) => handleTextBanner2Change('title', e.target.value)}
                        placeholder="Enter text banner 2 title"
                        required
                        disabled={isSubmitting}
                      />
                      {errors['textBanner2.title'] && <p className="error-text">{errors['textBanner2.title']}</p>}
                    </div>
                    <div>
                      <h2>Paragraphs *</h2>
                      {formData.textBanner2.paragraphs.map((para, index) => (
                        <div key={index} style={{ marginBottom: '10px' }} className="add_field titleField">
                          <textarea
                            value={para}
                            onChange={(e) => handleTextBanner2ParagraphChange(index, e.target.value)}
                            rows="3"
                            placeholder={`Text banner 2 paragraph ${index + 1}`}
                            disabled={isSubmitting}
                          />
                          {formData.textBanner2.paragraphs.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeTextBanner2Paragraph(index)}
                              style={{
                                marginTop: '5px',
                                padding: '5px 15px',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '4px',
                              }}
                              disabled={isSubmitting}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={addTextBanner2Paragraph}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                          borderRadius: '4px',
                        }}
                        disabled={isSubmitting}
                      >
                        + Add Paragraph
                      </button>
                    </div>
                    <div className="add_field titleField">
                      <h2>Banner 4 Image </h2>
                      <input
                        type="file"
                        onChange={(e) => setTextBanner2ImageFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
                        disabled={isSubmitting}
                      />
                      {(textBanner2ImageFile || existingTextBanner2ImageUrl) && (
                        <div style={{ marginTop: '10px' }} className='wid-150'>
                          <img
                            alt="Banner 3"
                            src={textBanner2ImageFile ? URL.createObjectURL(textBanner2ImageFile) : config.BASE_URL + '/' + existingTextBanner2ImageUrl}
                            style={{ maxWidth: '100%', height: 'auto' }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Disclaimer</h4>
                    <div className="add_field titleField">
                      <h2>Title *</h2>
                      <input
                        type="text"
                        value={formData.disclaimer.title}
                        onChange={(e) => handleDisclaimerChange('title', e.target.value)}
                        placeholder="Disclaimer title"
                        required
                        disabled={isSubmitting}
                      />
                      {errors['disclaimer.title'] && <p className="error-text">{errors['disclaimer.title']}</p>}
                    </div>
                    <div className="add_field textareaField">
                      <h2>Text *</h2>
                      <textarea
                        value={formData.disclaimer.text}
                        onChange={(e) => handleDisclaimerChange('text', e.target.value)}
                        rows="4"
                        placeholder="Disclaimer text"
                        required
                        disabled={isSubmitting}
                      />
                      {errors['disclaimer.text'] && <p className="error-text">{errors['disclaimer.text']}</p>}
                    </div>
                    <div className="add_field titleField">
                      <h2>Disclaimer Video </h2>
                      <input
                        type="file"
                        onChange={(e) => setDisclaimerVideoFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
                        disabled={isSubmitting}
                      />
                      {(disclaimerVideoFile || existingDisclaimerVideoUrl) && (
                        <div style={{ marginTop: '10px' }} className='wid-150'>
                          <video
                            controls
                            src={disclaimerVideoFile ? URL.createObjectURL(disclaimerVideoFile) : config.BASE_URL + '/' + existingDisclaimerVideoUrl}
                            style={{ maxWidth: '100%', height: 'auto' }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Spanish Content */}
              {activeLanguage === 'es' && (
                <div>
                  <h3 style={{ color: '#fff', marginBottom: '20px' }}>Spanish Content (Contenido en Español)</h3>

                  {/* Spanish Hero Section */}
                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Banner 1</h4>
                    <div className="add_field titleField">
                      <h2>Título</h2>
                      <input
                        type="text"
                        value={spanishData.hero.title}
                        onChange={(e) => handleSpanishHeroChange('title', e.target.value)}
                        placeholder="Ingrese el título del hero"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="add_field titleField">
                      <h2>Subtítulo</h2>
                      <input
                        type="text"
                        value={spanishData.hero.subtitle}
                        onChange={(e) => handleSpanishHeroChange('subtitle', e.target.value)}
                        placeholder="Ingrese el subtítulo del hero"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div>
                      <h2>Párrafos</h2>
                      {spanishData.hero.paragraphs.map((para, index) => (
                        <div key={index} style={{ marginBottom: '10px' }} className="add_field titleField">
                          <textarea
                            value={para}
                            onChange={(e) => handleSpanishHeroParagraphChange(index, e.target.value)}
                            rows="3"
                            placeholder={`Párrafo ${index + 1}`}
                            disabled={isSubmitting}
                          />
                          {spanishData.hero.paragraphs.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeSpanishHeroParagraph(index)}
                              style={{
                                marginTop: '5px',
                                padding: '5px 15px',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '4px',
                              }}
                              disabled={isSubmitting}
                            >
                              Eliminar
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={addSpanishHeroParagraph}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                          borderRadius: '4px',
                        }}
                        disabled={isSubmitting}
                      >
                        + Agregar Párrafo
                      </button>
                    </div>
                  </div>

                  {/* Spanish Navigation */}
                  {/* <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Navegación</h4>
                    <div className="add_field titleField">
                      <h2>Sobre Nosotros</h2>
                      <input
                        type="text"
                        value={spanishData.navigation.aboutUs}
                        onChange={(e) => handleSpanishNavigationChange('aboutUs', e.target.value)}
                        placeholder="Texto de navegación Sobre Nosotros"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="add_field titleField">
                      <h2>Nuestro Equipo</h2>
                      <input
                        type="text"
                        value={spanishData.navigation.ourTeam}
                        onChange={(e) => handleSpanishNavigationChange('ourTeam', e.target.value)}
                        placeholder="Texto de navegación Nuestro Equipo"
                        disabled={isSubmitting}
                      />
                    </div>
                  </div> */}

                  {/* Spanish Text Banner */}
                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Banner 2</h4>
                    <div className="add_field titleField">
                      <h2>Título</h2>
                      <input
                        type="text"
                        value={spanishData.textBanner.title}
                        onChange={(e) => handleSpanishTextBannerChange('title', e.target.value)}
                        placeholder="Ingrese el título del banner"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div>
                      <h2>Párrafos</h2>
                      {spanishData.textBanner.paragraphs.map((para, index) => (
                        <div key={index} style={{ marginBottom: '10px' }} className="add_field titleField">
                          <textarea
                            value={para}
                            onChange={(e) => handleSpanishTextBannerParagraphChange(index, e.target.value)}
                            rows="3"
                            placeholder={`Párrafo ${index + 1}`}
                            disabled={isSubmitting}
                          />
                          {spanishData.textBanner.paragraphs.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeSpanishTextBannerParagraph(index)}
                              style={{
                                marginTop: '5px',
                                padding: '5px 15px',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '4px',
                              }}
                              disabled={isSubmitting}
                            >
                              Eliminar
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={addSpanishTextBannerParagraph}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                          borderRadius: '4px',
                        }}
                        disabled={isSubmitting}
                      >
                        + Agregar Párrafo
                      </button>
                    </div>
                  </div>
                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Banner 3</h4>
                    <div className="add_field titleField">
                      <h2>Título</h2>
                      <input
                        type="text"
                        value={spanishData.section3.title}
                        onChange={(e) => handleSpanishSection3Change('title', e.target.value)}
                        placeholder="Título de la sección 3"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div>
                      <h2>Párrafos</h2>
                      {spanishData.section3.paragraphs.map((para, index) => (
                        <div key={index} style={{ marginBottom: '10px' }} className="add_field titleField">
                          <textarea
                            value={para}
                            onChange={(e) => handleSpanishSection3ParagraphChange(index, e.target.value)}
                            rows="3"
                            placeholder={`Párrafo ${index + 1}`}
                            disabled={isSubmitting}
                          />
                          {spanishData.section3.paragraphs.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeSpanishSection3Paragraph(index)}
                              style={{
                                marginTop: '5px',
                                padding: '5px 15px',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '4px',
                              }}
                              disabled={isSubmitting}
                            >
                              Eliminar
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={addSpanishSection3Paragraph}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                          borderRadius: '4px',
                        }}
                        disabled={isSubmitting}
                      >
                        + Agregar Párrafo
                      </button>
                    </div>
                  </div>
                  {/* Spanish Text Banner 2 */}
                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Banner 4</h4>
                    <div className="add_field titleField">
                      <h2>Título</h2>
                      <input
                        type="text"
                        value={spanishData.textBanner2.title}
                        onChange={(e) => handleSpanishTextBanner2Change('title', e.target.value)}
                        placeholder="Ingrese el título del banner 2"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div>
                      <h2>Párrafos</h2>
                      {spanishData.textBanner2.paragraphs.map((para, index) => (
                        <div key={index} style={{ marginBottom: '10px' }} className="add_field titleField">
                          <textarea
                            value={para}
                            onChange={(e) => handleSpanishTextBanner2ParagraphChange(index, e.target.value)}
                            rows="3"
                            placeholder={`Párrafo ${index + 1}`}
                            disabled={isSubmitting}
                          />
                          {spanishData.textBanner2.paragraphs.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeSpanishTextBanner2Paragraph(index)}
                              style={{
                                marginTop: '5px',
                                padding: '5px 15px',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '4px',
                              }}
                              disabled={isSubmitting}
                            >
                              Eliminar
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={addSpanishTextBanner2Paragraph}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                          borderRadius: '4px',
                        }}
                        disabled={isSubmitting}
                      >
                        + Agregar Párrafo
                      </button>
                    </div>
                  </div>

                  {/* Spanish Sections */}
                  {/* <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Títulos de Sección</h4>
                    <div className="add_field titleField">
                      <h2>Lo Que Ofrecemos</h2>
                      <input
                        type="text"
                        value={spanishData.sections.whatWeOffer}
                        onChange={(e) => handleSpanishSectionsChange('whatWeOffer', e.target.value)}
                        placeholder="Título de sección Lo Que Ofrecemos"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="add_field titleField">
                      <h2>Nuestro Proceso</h2>
                      <input
                        type="text"
                        value={spanishData.sections.ourProcess}
                        onChange={(e) => handleSpanishSectionsChange('ourProcess', e.target.value)}
                        placeholder="Título de sección Nuestro Proceso"
                        disabled={isSubmitting}
                      />
                    </div>
                  </div> */}

                  {/* Spanish Offers */}
                  {/* <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Ofertas</h4>
                    {spanishData.offers.map((offer, index) => (
                      <div key={index} style={{ marginBottom: '20px', padding: '15px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '6px' }}>
                        <h5 style={{ color: '#fff', marginBottom: '10px' }}>Oferta {index + 1}</h5>
                        <div className="add_field titleField">
                          <h2>URL del Icono</h2>
                          <input
                            type="text"
                            value={offer.icon}
                            onChange={(e) => handleSpanishOfferChange(index, 'icon', e.target.value)}
                            placeholder="URL o ruta del icono"
                            disabled={isSubmitting}
                          />
                        </div>
                        <div className="add_field titleField">
                          <h2>Título</h2>
                          <input
                            type="text"
                            value={offer.title}
                            onChange={(e) => handleSpanishOfferChange(index, 'title', e.target.value)}
                            placeholder="Título de la oferta"
                            disabled={isSubmitting}
                          />
                        </div>
                        <div className="add_field textareaField">
                          <h2>Descripción</h2>
                          <textarea
                            value={offer.desc}
                            onChange={(e) => handleSpanishOfferChange(index, 'desc', e.target.value)}
                            rows="3"
                            placeholder="Descripción de la oferta"
                            disabled={isSubmitting}
                          />
                        </div>
                        {spanishData.offers.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removeSpanishOffer(index)}
                            style={{
                              padding: '5px 15px',
                              backgroundColor: '#dc3545',
                              color: 'white',
                              border: 'none',
                              cursor: 'pointer',
                              borderRadius: '4px',
                            }}
                            disabled={isSubmitting}
                          >
                            Eliminar Oferta
                          </button>
                        )}
                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={addSpanishOffer}
                      style={{
                        padding: '8px 16px',
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        borderRadius: '4px',
                      }}
                      disabled={isSubmitting}
                    >
                      + Agregar Oferta
                    </button>
                  </div> */}

                  {/* Spanish Process */}
                  {/* <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Pasos del Proceso</h4>
                    {spanishData.process.map((proc, index) => (
                      <div key={index} style={{ marginBottom: '20px', padding: '15px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '6px' }}>
                        <h5 style={{ color: '#fff', marginBottom: '10px' }}>Paso {index + 1}</h5>
                        <div className="add_field titleField">
                          <h2>URL del Icono</h2>
                          <input
                            type="text"
                            value={proc.icon}
                            onChange={(e) => handleSpanishProcessChange(index, 'icon', e.target.value)}
                            placeholder="URL o ruta del icono"
                            disabled={isSubmitting}
                          />
                        </div>
                        <div className="add_field titleField">
                          <h2>Título</h2>
                          <input
                            type="text"
                            value={proc.title}
                            onChange={(e) => handleSpanishProcessChange(index, 'title', e.target.value)}
                            placeholder="Título del proceso"
                            disabled={isSubmitting}
                          />
                        </div>
                        <div className="add_field textareaField">
                          <h2>Descripción</h2>
                          <textarea
                            value={proc.desc}
                            onChange={(e) => handleSpanishProcessChange(index, 'desc', e.target.value)}
                            rows="3"
                            placeholder="Descripción del proceso"
                            disabled={isSubmitting}
                          />
                        </div>
                        {spanishData.process.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removeSpanishProcess(index)}
                            style={{
                              padding: '5px 15px',
                              backgroundColor: '#dc3545',
                              color: 'white',
                              border: 'none',
                              cursor: 'pointer',
                              borderRadius: '4px',
                            }}
                            disabled={isSubmitting}
                          >
                            Eliminar Paso
                          </button>
                        )}
                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={addSpanishProcess}
                      style={{
                        padding: '8px 16px',
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        borderRadius: '4px',
                      }}
                      disabled={isSubmitting}
                    >
                      + Agregar Paso del Proceso
                    </button>
                  </div> */}

                  {/* Spanish Disclaimer */}


                  {/* Spanish Section 3 */}

                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Descargo de Responsabilidad</h4>
                    <div className="add_field titleField">
                      <h2>Título</h2>
                      <input
                        type="text"
                        value={spanishData.disclaimer.title}
                        onChange={(e) => handleSpanishDisclaimerChange('title', e.target.value)}
                        placeholder="Título del descargo"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Texto</h2>
                      <textarea
                        value={spanishData.disclaimer.text}
                        onChange={(e) => handleSpanishDisclaimerChange('text', e.target.value)}
                        rows="4"
                        placeholder="Texto del descargo"
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className="add_project" style={{ marginTop: '30px' }}>
                <button type="submit" disabled={isSubmitting} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Save className="w-5 h-5" />
                  {isSubmitting ? 'Saving...' : isNewContent ? 'Save' : 'Save'}
                </button>
              </div>
            </form>

            {errors.submit && (
              <div
                style={{
                  padding: '12px',
                  marginTop: '20px',
                  backgroundColor: '#f8d7da',
                  border: '1px solid #f5c6cb',
                  borderRadius: '4px',
                  color: '#721c24',
                }}
              >
                {errors.submit}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacadePageManage;